(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5345],{

/***/ 85353:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product",
      function () {
        return __webpack_require__(14519);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 14519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ProductPage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/index.ts + 138 modules
var components = __webpack_require__(36357);
// EXTERNAL MODULE: ./src/gql/queries/index.ts + 45 modules
var queries = __webpack_require__(98);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@apollo/react-hooks/lib/react-hooks.esm.js
var react_hooks_esm = __webpack_require__(18499);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/toggled/dist/toggled.esm.js
var toggled_esm = __webpack_require__(67866);
// EXTERNAL MODULE: ./src/analytics/index.ts + 4 modules
var analytics = __webpack_require__(30588);
// EXTERNAL MODULE: ./src/components/wysiwyg/index.ts
var wysiwyg = __webpack_require__(58309);
// EXTERNAL MODULE: ./src/hooks/index.ts + 31 modules
var hooks = __webpack_require__(81251);
// EXTERNAL MODULE: ./src/hooks/use-variant-manager.ts
var use_variant_manager = __webpack_require__(31494);
// EXTERNAL MODULE: ./src/hooks/use-vendor.ts
var use_vendor = __webpack_require__(1360);
// EXTERNAL MODULE: ./src/layouts/index.ts + 17 modules
var layouts = __webpack_require__(63409);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/hooks/use-modal-manager.ts
var use_modal_manager = __webpack_require__(63637);
// EXTERNAL MODULE: ./src/truck/loader/index.tsx + 1 modules
var loader = __webpack_require__(88622);
// EXTERNAL MODULE: ./src/utils/index.ts + 24 modules
var utils = __webpack_require__(90644);
// EXTERNAL MODULE: ./node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(66688);
// EXTERNAL MODULE: ./node_modules/styled-breakpoints/index.js
var styled_breakpoints = __webpack_require__(94698);
// EXTERNAL MODULE: ./src/components/modal/index.tsx + 4 modules
var modal = __webpack_require__(40519);
// EXTERNAL MODULE: ./src/truck/button/index.tsx + 2 modules
var truck_button = __webpack_require__(48721);
// EXTERNAL MODULE: ./src/truck/icon/index.tsx + 1 modules
var icon = __webpack_require__(63216);
// EXTERNAL MODULE: ./src/truck/input/index.tsx + 1 modules
var input = __webpack_require__(70974);
// EXTERNAL MODULE: ./src/truck/notifier/index.tsx + 2 modules
var notifier = __webpack_require__(5002);
// EXTERNAL MODULE: ./src/truck/text-area/index.tsx
var text_area = __webpack_require__(32521);
// EXTERNAL MODULE: ./src/truck/theme.ts
var theme = __webpack_require__(78904);
// EXTERNAL MODULE: ./src/utils/cloudinary.ts
var cloudinary = __webpack_require__(61761);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(13135);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 15 modules
var lib = __webpack_require__(91239);
;// CONCATENATED MODULE: ./src/modules/reviews/gql/fragments/review-fragment.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment review on Review {\n    id\n    title\n    comment\n    rating\n    isVerified\n    updatedAt\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var reviewFragment = (0,lib/* default */.ZP)(_templateObject());
/* harmony default export */ var review_fragment = (reviewFragment);

;// CONCATENATED MODULE: ./src/modules/reviews/gql/mutations/upsert-review.ts

function upsert_review_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation upsertReview($productId: ID!, $title: String!, $comment: String!, $rating: Int!) {\n    upsertReview(input: { productId: $productId, title: $title, comment: $comment, rating: $rating }) {\n      review {\n        ...review\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    upsert_review_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var upsertReviewMutation = (0,lib/* default */.ZP)(upsert_review_templateObject(), review_fragment);
/* harmony default export */ var upsert_review = (upsertReviewMutation);

// EXTERNAL MODULE: ./src/modules/reviews/components/upsert-review-modal/rating-message.tsx
var rating_message = __webpack_require__(58731);
;// CONCATENATED MODULE: ./src/modules/reviews/components/upsert-review-modal/index.tsx





function upsert_review_modal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: ",
        "px;\n  padding: ",
        "px ",
        "px;\n  resize: none;\n"
    ]);
    upsert_review_modal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: ",
        "px;\n  object-fit: cover;\n  width: ",
        "px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  height: 100%;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: ",
        "px;\n  display: flex;\n  height: ",
        "px;\n  margin-bottom: ",
        "px;\n  padding: ",
        "px;\n\n  ",
        " {\n    margin-left: ",
        "px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: ",
        "px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > span {\n    > span {\n      margin: 0 ",
        "px;\n    }\n\n    > :first-child {\n      margin-left: 0;\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin-bottom: ",
        "px;\n\n  ",
        " {\n    align-items: flex-start;\n  }\n\n  > :first-child {\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: ",
        "px;\n  }\n\n  > :last-child {\n    align-items: center;\n    display: flex;\n    justify-content: center;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        "px;\n\n  p {\n    margin-bottom: ",
        "px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        "px;\n\n  p {\n    margin-bottom: ",
        "px;\n  }\n\n  ",
        " {\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background-color: ",
        ";\n  bottom: 0;\n  box-shadow: 0px -2px 5px rgba(0, 0, 0, 0.08);\n  display: flex;\n  height: ",
        "px;\n  left: 0;\n  position: fixed;\n  right: 0;\n\n  > button {\n    margin: 0 ",
        "px;\n  }\n\n  > :last-child {\n    margin-left: 0;\n  }\n\n  ",
        " {\n    justify-content: flex-end;\n\n    button {\n      margin: 0;\n      width: ",
        "px;\n    }\n\n    > :last-child {\n      margin: 0 ",
        "px;\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    min-height: ",
        "px;\n    padding: ",
        "px;\n    width: ",
        "px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}




















var StyledTextArea = (0,styled_components_browser_esm/* default */.ZP)(text_area/* default */.Z).withConfig({
    componentId: "sc-15b5947e-0"
})(upsert_review_modal_templateObject(), theme/* default.spacing.cozy */.Z.spacing.cozy * 6, theme/* default.spacing.compact */.Z.spacing.compact * 2.5, theme/* default.spacing.comfortable */.Z.spacing.comfortable);
var ProductDetail = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-15b5947e-1"
})(_templateObject1());
var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-15b5947e-2"
})(_templateObject2(), theme/* default.spacing.cozy */.Z.spacing.cozy * 9, theme/* default.spacing.cozy */.Z.spacing.cozy * 9);
var ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-15b5947e-3"
})(_templateObject3());
var Product = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-15b5947e-4"
})(_templateObject4(), theme/* default.colors.grayLight */.Z.colors.grayLight, theme/* default.spacing.compact */.Z.spacing.compact, theme/* default.spacing.cozy */.Z.spacing.cozy * 15, theme/* default.spacing.cozy */.Z.spacing.cozy * 3, theme/* default.spacing.cozy */.Z.spacing.cozy * 2, ProductDetail, theme/* default.spacing.cozy */.Z.spacing.cozy * 3);
var Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-15b5947e-5"
})(_templateObject5(), theme/* default.spacing.cozy */.Z.spacing.cozy * 3);
var StyledRating = (0,styled_components_browser_esm/* default */.ZP)(components/* Rating */.iG).withConfig({
    componentId: "sc-15b5947e-6"
})(_templateObject6(), theme/* default.spacing.cozy */.Z.spacing.cozy);
var Qualification = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-15b5947e-7"
})(_templateObject7(), theme/* default.spacing.cozy */.Z.spacing.cozy * 3, (0,styled_breakpoints.up)("lg"), theme/* default.spacing.cozy */.Z.spacing.cozy * 2);
var Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-15b5947e-8"
})(_templateObject8(), theme/* default.spacing.cozy */.Z.spacing.cozy * 3, theme/* default.spacing.cozy */.Z.spacing.cozy);
var Comment = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-15b5947e-9"
})(_templateObject9(), theme/* default.spacing.cozy */.Z.spacing.cozy * 15, theme/* default.spacing.cozy */.Z.spacing.cozy, (0,styled_breakpoints.up)("lg"));
var ButtonsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-15b5947e-10"
})(_templateObject10(), theme/* default.colors.white */.Z.colors.white, theme/* default.spacing.cozy */.Z.spacing.cozy * 10, theme/* default.spacing.cozy */.Z.spacing.cozy * 2, (0,styled_breakpoints.up)("lg"), theme/* default.spacing.cozy */.Z.spacing.cozy * 19, theme/* default.spacing.cozy */.Z.spacing.cozy * 3);
var StyledModal = (0,styled_components_browser_esm/* default */.ZP)(modal/* default */.Z).withConfig({
    componentId: "sc-15b5947e-11"
})(_templateObject11(), (0,styled_breakpoints.up)("lg"), theme/* default.spacing.cozy */.Z.spacing.cozy * 78, theme/* default.spacing.cozy */.Z.spacing.cozy * 3, theme/* default.spacing.cozy */.Z.spacing.cozy * 77);
var UpsertReviewModal = function(props) {
    var product = props.product, initialValues = props.initialValues;
    var isNewReview = (0,lodash.isEmpty)(initialValues);
    var ref = (0,_sliced_to_array/* default */.Z)((0,react_hooks_esm/* useMutation */.Db)(upsert_review), 2), upsertReview = ref[0], loading = ref[1].loading;
    var ref1 = (0,react.useState)(undefined), hoverMessage = ref1[0], setHoverMessage = ref1[1];
    var ref2 = (0,react.useState)(initialValues.rating || 5), rating = ref2[0], setRating = ref2[1];
    var ref3 = (0,react.useState)(initialValues.comment || ""), comment = ref3[0], setComment = ref3[1];
    var ref4 = (0,react.useState)(initialValues.title || ""), title = ref4[0], setTitle = ref4[1];
    var modalManager = (0,use_modal_manager/* default */.Z)();
    (0,react.useEffect)(function() {
        setHoverMessage(constants/* messagesRatingWhenHovering */.C6[rating - 1]);
    }, [
        rating
    ]);
    var onClose = function() {
        modalManager.closeModal();
    };
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var options;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        options = {
                            variables: {
                                productId: product.id,
                                title: title,
                                comment: comment,
                                rating: rating
                            },
                            refetchQueries: [
                                "productReviews"
                            ],
                            awaitRefetchQueries: true
                        };
                        return [
                            4,
                            upsertReview(options)
                        ];
                    case 1:
                        _state.sent();
                        if (isNewReview) {
                            notifier/* default.success */.Z.success("\xa1Rese\xf1a creada exit\xf3samente!");
                        } else {
                            notifier/* default.success */.Z.success("\xa1Rese\xf1a actualizada exit\xf3samente!");
                        }
                        onClose();
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var inputChange = function(event, setter) {
        setter(event.target.value);
    };
    var onClickRating = function(value) {
        setRating(value);
        setHoverMessage(constants/* messagesRatingWhenHovering */.C6[value - 1]);
    };
    var onHoverRating = function(value) {
        if (value) {
            setHoverMessage(constants/* messagesRatingWhenHovering */.C6[value - 1]);
        } else {
            setHoverMessage(constants/* messagesRatingWhenHovering */.C6[rating - 1]);
        }
    };
    var photo = cloudinary/* default.applyTransformations */.Z.applyTransformations(product.defaultPhoto, constants/* transformations.TINY_PRODUCT */.S7.TINY_PRODUCT);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledModal, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Form */.l0, {
            onSubmit: onSubmit,
            children: function(formProps) {
                var handleSubmit = formProps.handleSubmit;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-xl font-semibold",
                                    children: isNewReview ? "Escribir una rese\xf1a del producto" : "Actualizar rese\xf1a del producto"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                    type: "close",
                                    color: "black",
                                    onClick: onClose
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Product, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                        src: photo,
                                        alt: product.name
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDetail, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "font-semibold",
                                            children: product.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: product.presentation
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Price */.tA, {
                                            allowTaxLabel: true,
                                            oldValue: product.pricing.oldPrice,
                                            value: product.pricing.price,
                                            textStyle: "h5Semibold"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Qualification, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "font-semibold",
                                            children: "Califica este producto"
                                        }),
                                        hoverMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Media */.pU, {
                                            mobile: /*#__PURE__*/ (0,jsx_runtime.jsx)(rating_message/* default */.Z, (0,_object_spread/* default */.Z)({}, hoverMessage))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRating, {
                                            initialRating: rating,
                                            readonly: false,
                                            onClick: onClickRating,
                                            onHover: onHoverRating,
                                            imageStyle: {
                                                width: theme/* default.spacing.cozy */.Z.spacing.cozy * 4,
                                                height: theme/* default.spacing.cozy */.Z.spacing.cozy * 4
                                            }
                                        }),
                                        hoverMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Media */.pU, {
                                            desktop: /*#__PURE__*/ (0,jsx_runtime.jsx)(rating_message/* default */.Z, (0,_object_spread/* default */.Z)({}, hoverMessage))
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "font-semibold",
                                    children: "T\xedtulo"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                                    placeholder: "\xa1El producto est\xe1 incre\xedble!",
                                    value: title,
                                    onChange: function(event) {
                                        return inputChange(event, setTitle);
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Comment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "font-semibold",
                                    children: "Comentarios"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTextArea, {
                                    placeholder: "Es de buena calidad...",
                                    value: comment,
                                    onChange: function(event) {
                                        return inputChange(event, setComment);
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonsContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(truck_button/* default.Ghost */.Z.Ghost, {
                                    color: "secondary",
                                    onClick: onClose,
                                    children: "Cancelar"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(truck_button/* default */.Z, {
                                    type: "submit",
                                    color: "primary",
                                    loading: !!loading,
                                    onClick: handleSubmit,
                                    children: isNewReview ? "Publicar" : "Actualizar"
                                })
                            ]
                        })
                    ]
                });
            }
        })
    });
};
/* harmony default export */ var upsert_review_modal = (UpsertReviewModal);

// EXTERNAL MODULE: ./src/gql/fragments/index.ts + 20 modules
var fragments = __webpack_require__(32281);
;// CONCATENATED MODULE: ./src/modules/reviews/gql/queries/product-reviews.ts

function product_reviews_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query productReviews($slug: String!, $page: Int, $limit: Int) {\n    vendor {\n      id\n      product(slug: $slug) {\n        id\n        defaultPhoto\n        name\n        presentation\n        pricing {\n          oldPrice\n          price\n          ribbonLabel\n          isTaxExempt\n        }\n        reviewStats {\n          rating\n          numOfReviews\n          oneStar\n          twoStars\n          threeStars\n          fourStars\n          fiveStars\n        }\n        reviews(page: $page, limit: $limit) {\n          items {\n            ...review\n            reviewer {\n              id\n              fullName\n            }\n          }\n          pageInfo {\n            ...pageInfo\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    product_reviews_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var productReviewsQuery = (0,lib/* default */.ZP)(product_reviews_templateObject(), fragments/* pageInfoFragment */.z_, review_fragment);
/* harmony default export */ var product_reviews = (productReviewsQuery);

// EXTERNAL MODULE: ./node_modules/isomorphic-cookie/dist/index.js
var dist = __webpack_require__(38139);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./src/utils/redirect-to.ts
var redirect_to = __webpack_require__(53337);
;// CONCATENATED MODULE: ./src/modules/reviews/containers/product-review/ProductReviews.utils.ts



var useTextContent = function(opts) {
    if (!opts.isLoggedIn) {
        return {
            buttonAction: "Inicia sesi\xf3n para escribir una rese\xf1a",
            label: "Inicia sesi\xf3n y s\xe9 el primero en compartir tu opini\xf3n.",
            onClick: function() {
                dist_default().save(constants/* cookieNames.CALLBACK_URL */.Qo.CALLBACK_URL, opts.router.asPath, {
                    secure: false
                });
                return (0,redirect_to/* default */.Z)("/login");
            }
        };
    }
    return {
        buttonAction: "Escribe una rese\xf1a",
        label: "S\xe9 el primero en compartir tu opini\xf3n.",
        onClick: function() {
            opts.onStartReview();
        }
    };
};

// EXTERNAL MODULE: ./node_modules/react-infinite-scroller/index.js
var react_infinite_scroller = __webpack_require__(246);
var react_infinite_scroller_default = /*#__PURE__*/__webpack_require__.n(react_infinite_scroller);
// EXTERNAL MODULE: ./src/components/media/index.ts
var media = __webpack_require__(43902);
// EXTERNAL MODULE: ./src/truck/image/index.tsx
var truck_image = __webpack_require__(52679);
;// CONCATENATED MODULE: ./src/modules/reviews/components/empty-state.tsx



function EmptyState(param) {
    var imageUrl = param.imageUrl, buttonAction = param.buttonAction, label = param.label, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-6 flex gap-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(truck_image/* default */.Z, {
                        className: "size-16",
                        src: imageUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col justify-center gap-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-semibold",
                                children: "Este producto a\xfan no tiene rese\xf1as"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: label
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "cursor-pointer font-semibold text-brand-secondary",
                onClick: onClick,
                children: buttonAction
            })
        ]
    });
}
/* harmony default export */ var empty_state = (EmptyState);

// EXTERNAL MODULE: ./src/components/rating/index.js + 1 modules
var components_rating = __webpack_require__(88399);
// EXTERNAL MODULE: ./src/truck/label/index.tsx
var truck_label = __webpack_require__(67734);
;// CONCATENATED MODULE: ./src/modules/reviews/components/rating-graph.tsx

function rating_graph_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  > :not(:last-child) {\n    margin-bottom: ",
        "px;\n  }\n\n  ",
        " {\n    width: ",
        "px;\n  }\n"
    ]);
    rating_graph_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function rating_graph_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  width: 100%;\n\n  > :not(:last-child) {\n    margin-right: ",
        "px;\n  }\n"
    ]);
    rating_graph_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function rating_graph_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n"
    ]);
    rating_graph_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function rating_graph_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: ",
        "px;\n  height: ",
        "px;\n  width: 100%;\n"
    ]);
    rating_graph_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function rating_graph_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: ",
        "px;\n  height: ",
        "px;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: ",
        ";\n"
    ]);
    rating_graph_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}







var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bed903ea-0"
})(rating_graph_templateObject(), theme/* default.spacing.cozy */.Z.spacing.cozy, (0,styled_breakpoints.up)("lg"), theme/* default.spacing.cozy */.Z.spacing.cozy * 61);
var Box = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bed903ea-1"
})(rating_graph_templateObject1(), theme/* default.spacing.cozy */.Z.spacing.cozy);
var ProgressWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bed903ea-2"
})(rating_graph_templateObject2());
var ProgressBorder = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bed903ea-3"
})(rating_graph_templateObject3(), theme/* default.colors.gray */.Z.colors.gray, theme/* default.spacing.compact */.Z.spacing.compact, theme/* default.spacing.cozy */.Z.spacing.cozy);
var Progress = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bed903ea-4"
})(rating_graph_templateObject4(), function(props) {
    return props.$color;
}, theme/* default.spacing.compact */.Z.spacing.compact, theme/* default.spacing.cozy */.Z.spacing.cozy, function(props) {
    return props.$ratio;
});
var getPercentageValue = function(rate, total) {
    var ratio = rate / total * 100;
    return "".concat(ratio, "%");
};
var ReviewBar = function(props) {
    var label = props.label, color = props.color, total = props.total, rate = props.rate;
    var ratio = getPercentageValue(rate, total);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(truck_label/* default */.Z, {
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_rating/* default */.Z, {
                initialRating: 1,
                stop: 1
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProgressWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressBorder, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Progress, {
                        $color: color,
                        $ratio: ratio
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(truck_label/* default */.Z, {
                as: "span",
                $textStyle: "h5Semibold",
                style: {
                    width: 20
                },
                children: rate
            })
        ]
    });
};
var RatingGraph = function(props) {
    var color = props.color, oneStar = props.oneStar, twoStars = props.twoStars, threeStars = props.threeStars, fourStars = props.fourStars, fiveStars = props.fiveStars, numOfReviews = props.numOfReviews;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewBar, {
                label: 5,
                color: color,
                rate: fiveStars,
                total: numOfReviews
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewBar, {
                label: 4,
                color: color,
                rate: fourStars,
                total: numOfReviews
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewBar, {
                label: 3,
                color: color,
                rate: threeStars,
                total: numOfReviews
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewBar, {
                label: 2,
                color: color,
                rate: twoStars,
                total: numOfReviews
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewBar, {
                label: 1,
                color: color,
                rate: oneStar,
                total: numOfReviews
            })
        ]
    });
};
/* harmony default export */ var rating_graph = (RatingGraph);

;// CONCATENATED MODULE: ./src/modules/reviews/components/overview/index.tsx


function overview_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid ",
        ";\n  width: 100%;\n\n  > :last-child {\n    margin: ",
        "px 0;\n  }\n\n  ",
        " {\n    align-items: center;\n    align-self: center;\n    display: flex;\n    justify-content: center;\n    padding-bottom: ",
        "px;\n  }\n"
    ]);
    overview_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function overview_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin-bottom: ",
        "px;\n  margin-top: -",
        "px;\n\n  > :not(:last-child) {\n    margin-bottom: ",
        "px;\n  }\n\n  ",
        " {\n    margin-bottom: 0;\n    margin-right: ",
        "px;\n    margin-top: 0;\n    width: ",
        "px;\n  }\n"
    ]);
    overview_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function overview_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: ",
        "px;\n  padding: ",
        "px ",
        "px;\n\n  > :first-child {\n    margin-right: ",
        "px;\n  }\n"
    ]);
    overview_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var overview_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-797fdf5f-0"
})(overview_templateObject(), theme/* default.colors.gray */.Z.colors.gray, theme/* default.spacing.cozy */.Z.spacing.cozy * 3, (0,styled_breakpoints.up)("lg"), theme/* default.spacing.cozy */.Z.spacing.cozy * 4);
var overview_Box = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-797fdf5f-1"
})(overview_templateObject1(), theme/* default.spacing.cozy */.Z.spacing.cozy * 2, theme/* default.spacing.cozy */.Z.spacing.cozy, theme/* default.spacing.cozy */.Z.spacing.cozy, (0,styled_breakpoints.up)("lg"), theme/* default.spacing.cozy */.Z.spacing.cozy * 4, theme/* default.spacing.cozy */.Z.spacing.cozy * 14);
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-797fdf5f-2"
})(overview_templateObject2(), theme/* default.colors.grayLight */.Z.colors.grayLight, theme/* default.dimensions.borderRadius */.Z.dimensions.borderRadius, theme/* default.spacing.compact */.Z.spacing.compact, theme/* default.spacing.comfortable */.Z.spacing.comfortable, theme/* default.spacing.cozy */.Z.spacing.cozy);
var Overview = function(props) {
    var color = props.color, reviewStats = props.reviewStats, mobileData = props.mobileData;
    var numOfReviews = reviewStats.numOfReviews, rating = reviewStats.rating;
    var productReviews = mobileData.productReviews, onClick = mobileData.onClick, buttonAction = mobileData.buttonAction;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(overview_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(overview_Box, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-4xl font-semibold",
                                children: rating.toFixed(1)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-xl",
                                children: "/5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_rating/* default */.Z, {
                        initialRating: rating
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "w-max font-semibold",
                        children: [
                            numOfReviews,
                            " rese\xf1a",
                            numOfReviews > 1 && "s"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(rating_graph, (0,_object_spread/* default */.Z)({
                color: color
            }, reviewStats)),
            !(0,lodash.isEmpty)(productReviews) && /*#__PURE__*/ (0,jsx_runtime.jsx)(media/* default */.Z, {
                mobile: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-center font-semibold text-brand-secondary",
                    onClick: onClick,
                    children: buttonAction
                })
            })
        ]
    });
};
/* harmony default export */ var overview = (Overview);

// EXTERNAL MODULE: ./node_modules/moment-timezone/index.js
var moment_timezone = __webpack_require__(80008);
var moment_timezone_default = /*#__PURE__*/__webpack_require__.n(moment_timezone);
;// CONCATENATED MODULE: ./src/modules/reviews/components/product-review.tsx

function product_review_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin-top: ",
        "px;\n\n  > span:first-of-type {\n    margin-bottom: ",
        "px;\n  }\n\n  &:not(:last-child) {\n    border-bottom: 1px solid ",
        ";\n    padding-bottom: ",
        "px;\n  }\n"
    ]);
    product_review_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function product_review_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n\n  > div {\n    display: flex;\n    margin-bottom: ",
        "px;\n\n    > :first-child {\n      margin-right: ",
        "px;\n    }\n  }\n"
    ]);
    product_review_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function product_review_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  margin-bottom: ",
        "px;\n\n  svg {\n    margin-right: ",
        "px;\n  }\n"
    ]);
    product_review_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var product_review_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-74d79678-0"
})(product_review_templateObject(), theme/* default.spacing.relaxed */.Z.spacing.relaxed, theme/* default.spacing.cozy */.Z.spacing.cozy, theme/* default.colors.gray */.Z.colors.gray, theme/* default.spacing.relaxed */.Z.spacing.relaxed);
var Customer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-74d79678-1"
})(product_review_templateObject1(), theme/* default.spacing.cozy */.Z.spacing.cozy, theme/* default.spacing.cozy */.Z.spacing.cozy);
var ProductRating = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-74d79678-2"
})(product_review_templateObject2(), theme/* default.spacing.compact */.Z.spacing.compact * 3, theme/* default.spacing.compact */.Z.spacing.compact);
var ProductReview = function(props) {
    var title = props.title, comment = props.comment, rating = props.rating, isVerified = props.isVerified, updatedAt = props.updatedAt, reviewer = props.reviewer;
    var fullName = reviewer.fullName;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(product_review_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Customer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                type: "profile",
                                color: "black",
                                size: "sm",
                                interactive: false
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-xs font-semibold",
                                children: fullName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-xs font-semibold",
                        children: moment_timezone_default()(updatedAt).format("DD/MM/YYYY")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductRating, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Rating */.iG, {
                        initialRating: rating
                    }),
                    isVerified && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                className: "mx-2 text-neutral-300",
                                children: " • "
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                type: "check",
                                color: "success",
                                size: "sm",
                                interactive: false
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-xs font-semibold text-success",
                                children: "Compra Verificada"
                            })
                        ]
                    })
                ]
            }),
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "font-semibold",
                children: title
            }),
            comment && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "whitespace-pre-line",
                children: comment
            })
        ]
    });
};
/* harmony default export */ var product_review = (ProductReview);

;// CONCATENATED MODULE: ./src/modules/reviews/containers/product-review/ProductReviews.style.ts

function ProductReviews_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: ",
        "px;\n  display: flex;\n  flex-direction: column;\n  padding: ",
        "px;\n  width: 100%;\n\n  ",
        " {\n    margin: ",
        "px auto 0 auto;\n    width: calc(100% - ",
        "px);\n  }\n"
    ]);
    ProductReviews_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductReviews_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: ",
        "px;\n\n  > span:last-of-type {\n    cursor: pointer;\n    width: fit-content;\n  }\n"
    ]);
    ProductReviews_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var ContentContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-23ae1128-0"
})(ProductReviews_style_templateObject(), theme/* default.colors.white */.Z.colors.white, theme/* default.dimensions.borderRadius */.Z.dimensions.borderRadius, theme/* default.spacing.comfortable */.Z.spacing.comfortable, (0,styled_breakpoints.up)("lg"), theme/* default.spacing.comfortable */.Z.spacing.comfortable, theme/* default.spacing.cozy */.Z.spacing.cozy * 4);
var ProductReviewsHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-23ae1128-1"
})(ProductReviews_style_templateObject1(), theme/* default.spacing.relaxed */.Z.spacing.relaxed);

;// CONCATENATED MODULE: ./src/modules/reviews/containers/product-review/ProductReviews.view.tsx













var ProductReviewsView = function(props) {
    var reviewButtonContent = props.reviewButtonContent, imageUrl = props.imageUrl, reviewStats = props.reviewStats, pageInfo = props.pageInfo, loadMore = props.loadMore, productReviews = props.productReviews;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentContainer, {
        style: {
            marginTop: theme/* default.spacing.comfortable */.Z.spacing.comfortable
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductReviewsHeader, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: "text-xl font-semibold",
                        children: "Rese\xf1as del producto"
                    }),
                    !(0,lodash.isEmpty)(productReviews) && /*#__PURE__*/ (0,jsx_runtime.jsx)(media/* default */.Z, {
                        desktop: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "font-semibold text-brand-secondary",
                            onClick: reviewButtonContent.onClick,
                            children: reviewButtonContent.buttonAction
                        })
                    })
                ]
            }),
            (0,lodash.isEmpty)(productReviews) && /*#__PURE__*/ (0,jsx_runtime.jsx)(empty_state, {
                imageUrl: imageUrl,
                buttonAction: reviewButtonContent.buttonAction,
                label: reviewButtonContent.label,
                onClick: reviewButtonContent.onClick
            }),
            !(0,lodash.isEmpty)(productReviews) && !(0,lodash.isEmpty)(reviewStats) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(overview, {
                        color: constants/* ratingColor */.u2,
                        reviewStats: reviewStats,
                        mobileData: {
                            productReviews: productReviews,
                            onClick: reviewButtonContent.onClick,
                            buttonAction: reviewButtonContent.buttonAction
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((react_infinite_scroller_default()), {
                        loader: /*#__PURE__*/ (0,jsx_runtime.jsx)(loader/* default */.Z, {
                            centered: true
                        }, 0),
                        pageStart: 1,
                        hasMore: pageInfo.hasNextPage,
                        initialLoad: true,
                        loadMore: loadMore,
                        children: (0,lodash.map)(productReviews, function(review) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(product_review, (0,_object_spread/* default */.Z)({}, review), review.id);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ProductReviews_view = (ProductReviewsView);

;// CONCATENATED MODULE: ./src/modules/reviews/containers/product-review/ProductReviews.tsx














var ProductReviews = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var productSlug = props.productSlug;
    var router = (0,next_router.useRouter)();
    var ref9 = (0,use_modal_manager/* useSecureModalManager */.r)(upsert_review_modal), openReviewModal = ref9.open;
    var ref10 = (0,hooks/* useUser */.aF)(), userId = ref10.id, isLoggedIn = ref10.isLoggedIn;
    var ref11 = (0,react_hooks_esm/* useQuery */.aM)(product_reviews, {
        variables: {
            slug: productSlug,
            page: 1,
            limit: 5
        }
    }), loading = ref11.loading, data = ref11.data, fetchMore = ref11.fetchMore;
    var product = data === null || data === void 0 ? void 0 : (ref = data.vendor) === null || ref === void 0 ? void 0 : ref.product;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var loadMore = react.useCallback((0,lodash.debounce)(function(page) {
        return fetchMore({
            updateQuery: utils/* queryUpdater */.c_,
            variables: {
                page: page
            }
        });
    }, 500), [
        fetchMore
    ]);
    var pageInfo = data === null || data === void 0 ? void 0 : (ref1 = data.vendor) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.product) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.reviews) === null || ref3 === void 0 ? void 0 : ref3.pageInfo;
    var ref12;
    var reviewStats = (ref12 = data === null || data === void 0 ? void 0 : (ref4 = data.vendor) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.product) === null || ref5 === void 0 ? void 0 : ref5.reviewStats) !== null && ref12 !== void 0 ? ref12 : {};
    var url = utils/* cloudinary.getFullUrl */.nl.getFullUrl("v1588089460/sellers-panel/empty_rating.png");
    var imageUrl = utils/* cloudinary.applyTransformations */.nl.applyTransformations(url);
    var ref13;
    var productReviews = (ref13 = data === null || data === void 0 ? void 0 : (ref6 = data.vendor) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.product) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.reviews) === null || ref8 === void 0 ? void 0 : ref8.items) !== null && ref13 !== void 0 ? ref13 : [];
    var upsertInitialValues = {};
    if (productReviews.length > 0) {
        if (productReviews[0].reviewer.id === userId) {
            upsertInitialValues = (0,_object_spread/* default */.Z)({}, productReviews[0]);
        }
    }
    var reviewButtonContent = useTextContent({
        isLoggedIn: isLoggedIn,
        router: router,
        onStartReview: function() {
            openReviewModal({
                product: product,
                initialValues: upsertInitialValues
            });
        }
    });
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(loader/* default */.Z, {
            centered: true,
            style: {
                width: "100%"
            }
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductReviews_view, {
        reviewButtonContent: reviewButtonContent,
        imageUrl: imageUrl,
        reviewStats: reviewStats,
        pageInfo: pageInfo,
        loadMore: loadMore,
        productReviews: productReviews
    });
};
/* harmony default export */ var product_review_ProductReviews = (ProductReviews);

;// CONCATENATED MODULE: ./src/modules/reviews/containers/product-review/index.ts

/* harmony default export */ var containers_product_review = (product_review_ProductReviews);

// EXTERNAL MODULE: ./src/utils/is-browser.ts
var is_browser = __webpack_require__(56372);
// EXTERNAL MODULE: ./node_modules/react-html-parser/lib/index.js
var react_html_parser_lib = __webpack_require__(30653);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/truck/anchor/index.ts
var truck_anchor = __webpack_require__(75689);
;// CONCATENATED MODULE: ./src/screens/product/breadcrumb/elements.ts

function elements_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  margin-bottom: ",
        "px;\n\n  > svg {\n    height: ",
        "px;\n    width: ",
        "px;\n  }\n\n  > :not(:last-child) {\n    margin-right: ",
        "px;\n  }\n"
    ]);
    elements_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function elements_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: auto;\n"
    ]);
    elements_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var elements_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c714e248-0"
})(elements_templateObject(), theme/* default.spacing.comfortable */.Z.spacing.comfortable, theme/* default.spacing.comfortable */.Z.spacing.comfortable, theme/* default.spacing.comfortable */.Z.spacing.comfortable, theme/* default.spacing.cozy */.Z.spacing.cozy);
var StyledAnchor = (0,styled_components_browser_esm/* default */.ZP)(truck_anchor/* default */.Z).withConfig({
    componentId: "sc-c714e248-1"
})(elements_templateObject1());

;// CONCATENATED MODULE: ./src/screens/product/breadcrumb/index.tsx








var Breadcrumb = function(props) {
    var items = props.items, productIsAvailable = props.productIsAvailable;
    var renderItem = function(item, index) {
        var label = item.label, route = item.route;
        if (!label) {
            return null;
        }
        var isLast = index === items.length - 1;
        if (isLast) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(truck_label/* default */.Z, {
                $textStyle: "h5Semibold",
                $ellipsis: true,
                children: (0,react_html_parser_lib/* default */.ZP)(label)
            }, label);
        }
        var disabled = route !== "/" && !productIsAvailable;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: route,
                    passHref: !disabled,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAnchor, {
                        $color: "black",
                        $disabled: disabled,
                        children: label
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                    type: "caret-right",
                    color: "black"
                })
            ]
        }, label);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_Container, {
        children: (0,lodash.map)(items, renderItem)
    });
};
/* harmony default export */ var breadcrumb = (Breadcrumb);

// EXTERNAL MODULE: ./src/components/product/shared.tsx
var shared = __webpack_require__(95074);
// EXTERNAL MODULE: ./src/components/shipping-modal/index.tsx + 11 modules
var shipping_modal = __webpack_require__(65519);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(28668);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(26626);
;// CONCATENATED MODULE: ./src/screens/product/variant-selector/elements.js

function variant_selector_elements_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n\n  > * {\n    flex-basis: calc(50% - ",
        "px);\n    flex-grow: 1;\n  }\n\n  > :nth-child(even) {\n    margin-left: ",
        "px;\n  }\n\n  > :nth-child(odd):not(:last-child) {\n    margin-right: ",
        "px;\n  }\n"
    ]);
    variant_selector_elements_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var variant_selector_elements_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8bd99f9-0"
})(variant_selector_elements_templateObject(), theme/* default.spacing.cozy */.Z.spacing.cozy, theme/* default.spacing.compact */.Z.spacing.compact, theme/* default.spacing.compact */.Z.spacing.compact);

;// CONCATENATED MODULE: ./src/screens/product/variant-selector/index.js














var sizesOrder = {
    xs: 1,
    s: 2,
    m: 3,
    l: 4,
    xl: 5,
    xxl: 6,
    "2xl": 6,
    xxxl: 7,
    "3xl": 7,
    xxxxl: 8,
    "4xl": 8
};
var VariantSelector = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(VariantSelector, _Component);
    var _super = (0,_create_super/* default */.Z)(VariantSelector);
    function VariantSelector() {
        (0,_class_call_check/* default */.Z)(this, VariantSelector);
        var _this;
        _this = _super.apply(this, arguments);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "state", _this.getInitialState());
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "findAndNotifyChange", function() {
            var _props = _this.props, variants = _props.variants, onChange = _props.onChange;
            var selectedAttributes = _this.state.selectedAttributes;
            var matchProduct = (0,lodash.find)(variants, {
                refinedAttributes: selectedAttributes
            });
            onChange(matchProduct);
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "onAttributeSelectedChange", function(e) {
            var _target = e.target, name = _target.name, value = _target.value;
            _this.setState(function(prevState) {
                return {
                    selectedAttributes: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState.selectedAttributes), (0,_define_property/* default */.Z)({}, name, value))
                };
            }, _this.findAndNotifyChange);
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "renderContent", function() {
            var _props = _this.props, variantsAttributes = _props.fallbackProduct.variantsAttributes;
            var selectedAttributes = _this.state.selectedAttributes;
            var renderAttributeField = function(values, name) {
                var renderOption = function(value) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: value,
                        children: value
                    }, value);
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* TextField */.nv, {
                    name: name,
                    label: name,
                    as: "select",
                    standalone: true,
                    value: selectedAttributes[name],
                    onChange: _this.onAttributeSelectedChange,
                    children: (0,lodash.map)(values, renderOption)
                }, "attribute-".concat(name));
            };
            return (0,lodash.map)(variantsAttributes, function(values, name) {
                // NOTE: This is a one-time fix, if you need more than this one, please immplement a long-term solution
                if (name.toLowerCase() === "talla") {
                    var ref, ref1;
                    var orderedValues = (0,_to_consumable_array/* default */.Z)(values).sort(function(a, b) {
                        return ((ref = sizesOrder[a.toLowerCase()]) !== null && ref !== void 0 ? ref : 0) - ((ref1 = sizesOrder[b.toLowerCase()]) !== null && ref1 !== void 0 ? ref1 : 0);
                    });
                    return renderAttributeField(orderedValues, name);
                }
                return renderAttributeField(values, name);
            });
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(VariantSelector, [
        {
            key: "getInitialState",
            value: function getInitialState() {
                var _props = this.props, fallbackProduct = _props.fallbackProduct, activeVariant = _props.activeVariant;
                var ref;
                var selectedAttributes = (ref = activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.refinedAttributes) !== null && ref !== void 0 ? ref : fallbackProduct.refinedAttributes;
                return {
                    selectedAttributes: selectedAttributes
                };
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var prevFallbackProduct = prevProps.fallbackProduct;
                var _props = this.props, fallbackProduct = _props.fallbackProduct, activeVariant = _props.activeVariant;
                var isSameProduct = prevFallbackProduct.slug === fallbackProduct.slug;
                if (!(0,lodash.isEmpty)(activeVariant) && !isSameProduct) {
                    this.setState({
                        selectedAttributes: activeVariant.refinedAttributes
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, style = _props.style, className = _props.className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(variant_selector_elements_Container, {
                    style: style,
                    className: className,
                    children: this.renderContent()
                });
            }
        }
    ]);
    return VariantSelector;
}(react.Component);
/* harmony default export */ var variant_selector = (VariantSelector);

;// CONCATENATED MODULE: ./src/screens/product/cta/cta.style.ts

function cta_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        "px;\n  visibility: ",
        ";\n"
    ]);
    cta_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function cta_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        "px;\n"
    ]);
    cta_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var StyledAddToFavoritesButton = (0,styled_components_browser_esm/* default */.ZP)(components/* AddToFavoritesButtonDesktop */.Li).withConfig({
    componentId: "sc-dbc41525-0"
})(cta_style_templateObject(), theme/* default.spacing.compact */.Z.spacing.compact * 3, function(props) {
    return props.$visible ? "visible" : "hidden";
});
var StyledProductAttributes = (0,styled_components_browser_esm/* default */.ZP)(components/* ProductAttributes */.P$).withConfig({
    componentId: "sc-dbc41525-1"
})(cta_style_templateObject1(), theme/* default.spacing.relaxed */.Z.spacing.relaxed);

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./src/hooks/use-counter.ts
var use_counter = __webpack_require__(43031);
;// CONCATENATED MODULE: ./src/screens/product/cta/cta-basic-content.style.ts

function cta_basic_content_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  ",
        " {\n    flex-grow: 0;\n    max-width: 360px;\n  }\n"
    ]);
    cta_basic_content_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function cta_basic_content_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        "px;\n"
    ]);
    cta_basic_content_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function cta_basic_content_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  visibility: ",
        ";\n"
    ]);
    cta_basic_content_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var cta_basic_content_style_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-37f1ef9f-0"
})(cta_basic_content_style_templateObject(), (0,styled_breakpoints.up)("lg"));
var NamesContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-37f1ef9f-1"
})(cta_basic_content_style_templateObject1(), function(props) {
    return props.theme.spacing.cozy;
});
var StyledLabel = (0,styled_components_browser_esm/* default */.ZP)(truck_label/* default */.Z).withConfig({
    componentId: "sc-37f1ef9f-2"
})(cta_basic_content_style_templateObject2(), function(props) {
    return props.$visible ? "visible" : "hidden";
});

;// CONCATENATED MODULE: ./src/screens/product/cta/cta-basic-content.tsx











function CTABasicContent(props) {
    var activeVariant = props.activeVariant, presentation = props.presentation, name = props.name, children = props.children, sku = props.sku;
    var showSkuLabelFeature = (0,toggled_esm/* useFeature */.SS)(constants/* flags.SHOW_SKU_LABEL */.id.SHOW_SKU_LABEL);
    var showProductStockFeature = (0,toggled_esm/* useFeature */.SS)(constants/* flags.SHOW_PRODUCT_STOCK */.id.SHOW_PRODUCT_STOCK);
    var handleStockFeature = (0,toggled_esm/* useFeature */.SS)(constants/* flags.HANDLE_STOCK */.id.HANDLE_STOCK);
    var showPriceAfterLoginFeature = (0,toggled_esm/* useFeature */.SS)(constants/* flags.SHOW_PRICE_AFTER_LOGIN */.id.SHOW_PRICE_AFTER_LOGIN);
    var user = (0,hooks/* useUser */.aF)();
    var isVisitor = !user.isLoggedIn;
    var hidePrice = showPriceAfterLoginFeature && isVisitor;
    var canJumpAtLeastOnce = (0,utils/* validateIfCanJumpOnce */.Xw)(activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.jumpFactor, activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.minimumSalesQuantity, activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.maximumSalesQuantity);
    var handleSalesQuantity = (0,hooks/* useSalesQuantity */.FY)().handleSalesQuantity;
    var ref = handleSalesQuantity({
        stock: activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.stock,
        minimumSalesQuantity: activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.minimumSalesQuantity,
        maximumSalesQuantity: activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.maximumSalesQuantity
    }), counterMinValue = ref.counterMinValue, counterMaxValue = ref.counterMaxValue;
    var ref1 = (0,use_counter/* getQuantityRange */.t)({
        minValue: counterMinValue,
        maxValue: counterMaxValue,
        jumpFactor: activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.jumpFactor,
        allowZeroToEliminate: true
    }), maxStock = ref1.maxValue;
    var stockToDisplay = counterMaxValue ? maxStock : activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.stock;
    var shouldShowStock = showProductStockFeature && handleStockFeature && (activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.stock) > 0 && canJumpAtLeastOnce && !hidePrice;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(cta_basic_content_style_Container, {
        style: {
            gap: theme/* default.spacing.compact */.Z.spacing.compact * 3
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "text-xl font-semibold",
                children: (0,react_html_parser_lib/* default */.ZP)(name)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(cta_basic_content_style_Container, {
                style: {
                    gap: theme/* default.spacing.compact */.Z.spacing.compact
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: (0,clsx/* default */.Z)("text-secondary", activeVariant ? "visible" : "invisible"),
                        children: presentation
                    }),
                    showSkuLabelFeature ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                        className: (0,clsx/* default */.Z)("text-secondary", activeVariant ? "visible" : "invisible"),
                        children: [
                            "SKU: ",
                            sku
                        ]
                    }) : null
                ]
            }),
            shouldShowStock ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "text-green-600",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "font-semibold",
                        children: stockToDisplay > 9999 ? "+9999" : stockToDisplay
                    }),
                    " en stock"
                ]
            }) : null,
            children
        ]
    });
}

// EXTERNAL MODULE: ./src/components/add-to-cart-blocker/index.tsx
var add_to_cart_blocker = __webpack_require__(58144);
// EXTERNAL MODULE: ./src/components/counter/index.tsx + 8 modules
var counter = __webpack_require__(48632);
// EXTERNAL MODULE: ./src/components/unit-tooltip/index.tsx
var unit_tooltip = __webpack_require__(46341);
// EXTERNAL MODULE: ./src/variables.js
var variables = __webpack_require__(93063);
;// CONCATENATED MODULE: ./src/screens/product/cta/cta-counter.style.ts

function cta_counter_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  max-width: 50%;\n  position: relative;\n"
    ]);
    cta_counter_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function cta_counter_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  bottom: ",
        "px;\n  position: absolute;\n"
    ]);
    cta_counter_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var CounterContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8e6513df-0"
})(cta_counter_style_templateObject());
var StyledCounterError = (0,styled_components_browser_esm/* default */.ZP)(counter/* Counter.Error */.A.Error).withConfig({
    componentId: "sc-8e6513df-1"
})(cta_counter_style_templateObject1(), theme/* default.spacing.compact */.Z.spacing.compact * -5);

;// CONCATENATED MODULE: ./src/screens/product/cta/cta-counter.tsx















var CTACounter = function(props) {
    var ref;
    var activeVariant = props.activeVariant;
    var ref1 = (0,hooks/* useCartProps */.Ub)((0,_object_spread/* default */.Z)({}, activeVariant)), counterProps = ref1.counterProps, activeVariantStock = ref1.returnedStock;
    var isNotAvailable = (0,toggled_esm/* useFlag */.P5)(constants/* flags.NOT_AVAILABLE */.id.NOT_AVAILABLE);
    var hasUnits = (0,toggled_esm/* useFlag */.P5)(constants/* flags.UNITS */.id.UNITS);
    var stock = activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.stock;
    var ref2;
    var valueQuantity = (ref2 = activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.quantity) !== null && ref2 !== void 0 ? ref2 : 0;
    var ref3 = (0,react.useState)(valueQuantity), counterValue = ref3[0], setCounterValue = ref3[1];
    var ref4 = (0,react.useState)(null), counterError = ref4[0], setCounterError = ref4[1];
    if (!(0,lodash.isNil)(activeVariantStock)) {
        stock = activeVariantStock;
    }
    var isOutOfStock = stock <= 0 || !counterProps.canJumpAtLeastOnce;
    if (!activeVariant) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(truck_label/* default */.Z, {
            as: "span",
            $textStyle: "h3Semibold",
            children: "Variante no existe"
        });
    }
    if (isOutOfStock) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(truck_label/* default */.Z, {
            as: "span",
            $textStyle: "h3Semibold",
            children: "Fuera de stock"
        });
    }
    if (isNotAvailable) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(add_to_cart_blocker/* default */.Z, {
        component: CounterContainer,
        children: [
            !hasUnits ? /*#__PURE__*/ (0,jsx_runtime.jsx)(counter/* Counter */.A, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, counterProps), {
                alwaysOpen: true,
                onError: setCounterError
            })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(unit_tooltip/* UnitTooltip */.X, {
                visible: counterValue > 0,
                duration: shared/* unitTooltipDuration */.OD,
                salesUnitFactor: activeVariant.salesUnitFactor,
                inventoryUnitCode: (ref = activeVariant.inventoryUnit) === null || ref === void 0 ? void 0 : ref.code,
                quantity: counterValue,
                zIndex: variables/* stack.mainHeader */.kn.mainHeader - 1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(counter/* Counter */.A, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, counterProps), {
                    alwaysOpen: true,
                    onError: setCounterError,
                    onChange: function(value) {
                        counterProps.onChange(value);
                        setCounterValue(value);
                    }
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCounterError, {
                message: counterError
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/screens/product/cta/cta.tsx




















// TODO: Assign the types of props
var CTA = function(props) {
    var product = props.product;
    var openModal = (0,use_modal_manager/* default */.Z)().openModal;
    var showMyFavorites = (0,toggled_esm/* useFlag */.P5)(constants/* flags.MY_FAVORITES */.id.MY_FAVORITES);
    var showPriceAfterLoginFeature = (0,toggled_esm/* useFeature */.SS)(constants/* flags.SHOW_PRICE_AFTER_LOGIN */.id.SHOW_PRICE_AFTER_LOGIN);
    var shippingBeforeBuyFF = (0,toggled_esm/* useFeature */.SS)(constants/* flags.SHIPPING_BEFORE_BUY */.id.SHIPPING_BEFORE_BUY);
    var multiDistributorSession = (0,hooks/* useMultiDistributorSession */.kS)().multiDistributorSession;
    var user = (0,hooks/* useUser */.aF)();
    var hasAdvancedFiltersFF = (0,toggled_esm/* useFlag */.P5)(constants/* flags.ADVANCED_FILTERS */.id.ADVANCED_FILTERS);
    var getPriceVisibility = function() {
        var activeVariant = props.activeVariant;
        return activeVariant ? "visible" : "hidden";
    };
    var onSeePriceClick = function(productCallbackURL) {
        var ref, ref1;
        if ((shippingBeforeBuyFF === null || shippingBeforeBuyFF === void 0 ? void 0 : (ref = shippingBeforeBuyFF.settings) === null || ref === void 0 ? void 0 : ref.hidePrices) && !multiDistributorSession) {
            openModal(shipping_modal/* default */.Z);
            return;
        }
        if (showPriceAfterLoginFeature === null || showPriceAfterLoginFeature === void 0 ? void 0 : (ref1 = showPriceAfterLoginFeature.settings) === null || ref1 === void 0 ? void 0 : ref1.legacy) {
            openModal(components/* SignupToSeePricesForm */.rl);
            return;
        }
        dist_default().save(constants/* cookieNames.CALLBACK_URL */.Qo.CALLBACK_URL, productCallbackURL);
        (0,utils/* redirectTo */.gB)("/ingresar");
    };
    var renderContent = function() {
        var ref, ref1;
        var fallbackProduct = props.fallbackProduct, activeVariant = props.activeVariant, onVariantChange = props.onVariantChange, variants = props.variants;
        var pricing = activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.pricing;
        var isVisitor = !user.isLoggedIn;
        var hidePrice = showPriceAfterLoginFeature && isVisitor || !!(shippingBeforeBuyFF === null || shippingBeforeBuyFF === void 0 ? void 0 : (ref = shippingBeforeBuyFF.settings) === null || ref === void 0 ? void 0 : ref.hidePrices) && !multiDistributorSession;
        var shouldShowProductAttributes = !fallbackProduct.hasVariants && !(0,lodash.isNil)(product.attributes) && hasAdvancedFiltersFF;
        var price = (0,shared/* getPriceFromTier */.AZ)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, activeVariant !== null && activeVariant !== void 0 ? activeVariant : {}), {
            price: pricing === null || pricing === void 0 ? void 0 : pricing.price
        }));
        var productUrl = "/p/".concat((ref1 = props.activeVariant) === null || ref1 === void 0 ? void 0 : ref1.slug);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                !hidePrice ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Price */.tA, {
                    allowTaxLabel: true,
                    allowDiscountLabel: true,
                    oldValue: pricing === null || pricing === void 0 ? void 0 : pricing.oldPrice,
                    value: price,
                    textStyle: "h3Semibold",
                    style: {
                        visibility: getPriceVisibility(),
                        marginBottom: theme/* default.spacing.cozy */.Z.spacing.cozy * 5 + 2
                    },
                    isTaxExempt: pricing === null || pricing === void 0 ? void 0 : pricing.isTaxExempt,
                    tierPricing: activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.tierPricing,
                    salesUnitFactor: activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.salesUnitFactor
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(truck_button/* default */.Z, {
                    style: {
                        margin: "".concat(theme/* default.spacing.compact */.Z.spacing.compact * 5, "px 0px")
                    },
                    color: "secondary",
                    onClick: function() {
                        return onSeePriceClick(productUrl);
                    },
                    children: "Ver Precio"
                }),
                shouldShowProductAttributes && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProductAttributes, {
                    isCollapsible: true,
                    attributes: product.attributes
                }),
                fallbackProduct.hasVariants && /*#__PURE__*/ (0,jsx_runtime.jsx)(variant_selector, {
                    fallbackProduct: fallbackProduct,
                    activeVariant: activeVariant,
                    onChange: onVariantChange,
                    variants: variants,
                    style: {
                        marginBottom: theme/* default.spacing.compact */.Z.spacing.compact * 5
                    }
                }),
                !hidePrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(CTACounter, {
                    activeVariant: activeVariant
                })
            ]
        });
    };
    var activeVariant = props.activeVariant, fallbackProduct = props.fallbackProduct;
    var onToggleFavorite = (0,hooks/* useFavoriteProduct */.dv)(activeVariant !== null && activeVariant !== void 0 ? activeVariant : {}).onToggleFavorite;
    var ref;
    var name = (ref = activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.name) !== null && ref !== void 0 ? ref : fallbackProduct.name;
    var ref1;
    var presentation = (ref1 = activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.presentation) !== null && ref1 !== void 0 ? ref1 : fallbackProduct.presentation;
    var ref2;
    var sku = (ref2 = activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.sku) !== null && ref2 !== void 0 ? ref2 : fallbackProduct.sku;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CTABasicContent, {
        activeVariant: activeVariant,
        name: name,
        presentation: presentation,
        sku: sku,
        children: [
            renderContent(),
            showMyFavorites ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAddToFavoritesButton, {
                $visible: !!activeVariant,
                onClick: onToggleFavorite,
                favoriteSince: activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.favoriteSince
            }) : null
        ]
    });
};

;// CONCATENATED MODULE: ./src/screens/product/cta/index.ts



;// CONCATENATED MODULE: ./src/screens/product/elements.ts

function product_elements_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: ",
        "px;\n  display: flex;\n  flex-direction: column;\n  padding: ",
        "px;\n  width: 100%;\n\n  ",
        " {\n    margin: ",
        "px auto 0 auto;\n    width: calc(100% - ",
        "px);\n  }\n"
    ]);
    product_elements_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function product_elements_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  ",
        " {\n    flex-direction: row;\n  }\n\n  > :first-child {\n    margin-bottom: ",
        "px;\n\n    ",
        " {\n      margin-bottom: 0;\n      margin-right: ",
        "px;\n    }\n  }\n\n  > :first-child * {\n    ",
        " {\n      max-height: unset;\n    }\n  }\n\n  > :last-child {\n    flex-grow: 1;\n  }\n"
    ]);
    product_elements_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function elements_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n\n  > :first-child {\n    margin-bottom: ",
        "px;\n  }\n  margin-top: ",
        "px;\n  padding-bottom: ",
        "px;\n  position: relative;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    elements_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function elements_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: center;\n"
    ]);
    elements_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var elements_ContentContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-658ed840-0"
})(product_elements_templateObject(), theme/* default.colors.white */.Z.colors.white, theme/* default.dimensions.borderRadius */.Z.dimensions.borderRadius, theme/* default.spacing.comfortable */.Z.spacing.comfortable, (0,styled_breakpoints.up)("lg"), theme/* default.spacing.comfortable */.Z.spacing.comfortable, theme/* default.spacing.cozy */.Z.spacing.cozy * 4);
var InnerContentContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-658ed840-1"
})(product_elements_templateObject1(), (0,styled_breakpoints.up)("lg"), theme/* default.spacing.comfortable */.Z.spacing.comfortable, (0,styled_breakpoints.up)("lg"), theme/* default.spacing.cozy */.Z.spacing.cozy * 8, (0,styled_breakpoints.up)("lg"));
var AboutContainer = (0,styled_components_browser_esm/* default */.ZP)(elements_ContentContainer).withConfig({
    componentId: "sc-658ed840-2"
})(elements_templateObject2(), theme/* default.spacing.comfortable */.Z.spacing.comfortable, theme/* default.spacing.comfortable */.Z.spacing.comfortable, theme/* default.spacing.compact */.Z.spacing.compact * 13, function(param) {
    var clamped = param.clamped;
    return clamped && "\n    overflow: hidden;\n    max-height: ".concat(theme/* default.spacing.relaxed */.Z.spacing.relaxed * 11, "px;\n    padding-bottom: ").concat(theme/* default.spacing.compact */.Z.spacing.compact * 5, "px;\n  ");
}, function(param) {
    var clamped = param.clamped, showReadMore = param.showReadMore;
    return clamped && showReadMore && "\n    &::before {\n      content: '';\n      position: absolute;\n      bottom: 0;\n      left:0;\n      display: block;\n      width: 100%;\n      height: ".concat(theme/* default.spacing.comfortable */.Z.spacing.comfortable * 10, "px;\n      background: linear-gradient(0deg, ").concat(theme/* default.colors.white */.Z.colors.white, " 28.48%, rgba(255, 255, 255, 0.5) 68.26%, rgba(255, 255, 255, 0) 100%);\n    }\n  ");
});
var StyledErrorComponent = (0,styled_components_browser_esm/* default */.ZP)(components/* ErrorComponent */.qz).withConfig({
    componentId: "sc-658ed840-3"
})(elements_templateObject3());

;// CONCATENATED MODULE: ./node_modules/react-inner-image-zoom/es/InnerImageZoom/components/Image.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }




var Image_Image = function Image(_ref) {
  var src = _ref.src,
      sources = _ref.sources,
      width = _ref.width,
      height = _ref.height,
      hasSpacer = _ref.hasSpacer,
      imgAttributes = _ref.imgAttributes,
      isZoomed = _ref.isZoomed,
      fadeDuration = _ref.fadeDuration;
  var createSpacer = width && height && hasSpacer;
  return /*#__PURE__*/react.createElement("div", {
    style: {
      paddingTop: createSpacer ? height / width * 100 + "%" : null
    }
  }, sources && sources.length > 0 ? /*#__PURE__*/react.createElement("picture", null, sources.map(function (source, i) {
    return /*#__PURE__*/react.createElement(react.Fragment, {
      key: i
    }, source.srcSet && /*#__PURE__*/react.createElement("source", source));
  }), /*#__PURE__*/react.createElement("img", _extends({}, imgAttributes, {
    className: "iiz__img " + (imgAttributes.className || '') + " " + (isZoomed ? 'iiz__img--hidden' : '') + " " + (createSpacer ? 'iiz__img--abs' : ''),
    style: {
      transition: "opacity 0ms linear " + (isZoomed ? fadeDuration : 0) + "ms, visibility 0ms linear " + (isZoomed ? fadeDuration : 0) + "ms"
    },
    src: src,
    width: width,
    height: height
  }))) : /*#__PURE__*/react.createElement("img", _extends({}, imgAttributes, {
    className: "iiz__img " + (imgAttributes.className || '') + " " + (isZoomed ? 'iiz__img--hidden' : '') + " " + (createSpacer ? 'iiz__img--abs' : ''),
    style: {
      transition: "opacity 0ms linear " + (isZoomed ? fadeDuration : 0) + "ms, visibility 0ms linear " + (isZoomed ? fadeDuration : 0) + "ms"
    },
    src: src,
    width: width,
    height: height
  })));
};

Image_Image.propTypes =  false ? 0 : {};
/* harmony default export */ var components_Image = (Image_Image);
;// CONCATENATED MODULE: ./node_modules/react-inner-image-zoom/es/InnerImageZoom/components/ZoomImage.js



var ZoomImage = function ZoomImage(_ref) {
  var src = _ref.src,
      fadeDuration = _ref.fadeDuration,
      top = _ref.top,
      left = _ref.left,
      isZoomed = _ref.isZoomed,
      onLoad = _ref.onLoad,
      onDragStart = _ref.onDragStart,
      onDragEnd = _ref.onDragEnd,
      onClose = _ref.onClose,
      onFadeOut = _ref.onFadeOut;
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("img", {
    className: "iiz__zoom-img " + (isZoomed ? 'iiz__zoom-img--visible' : ''),
    style: {
      top: top,
      left: left,
      transition: "opacity " + fadeDuration + "ms linear, visibility " + fadeDuration + "ms linear"
    },
    src: src,
    onLoad: onLoad,
    onTouchStart: onDragStart,
    onTouchEnd: onDragEnd,
    onMouseDown: onDragStart,
    onMouseUp: onDragEnd,
    onTransitionEnd: onFadeOut,
    draggable: "false",
    alt: ""
  }), onClose && /*#__PURE__*/react.createElement("button", {
    className: "iiz__btn iiz__close " + (isZoomed ? 'iiz__close--visible' : ''),
    style: {
      transition: "opacity " + fadeDuration + "ms linear, visibility " + fadeDuration + "ms linear"
    },
    onClick: onClose,
    "aria-label": "Zoom Out"
  }));
};

ZoomImage.propTypes =  false ? 0 : {};
/* harmony default export */ var components_ZoomImage = (ZoomImage);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/react-inner-image-zoom/es/InnerImageZoom/components/FullscreenPortal.js




var FullscreenPortal = function FullscreenPortal(_ref) {
  var children = _ref.children;

  var _useState = (0,react.useState)(function () {
    var el = document.createElement('div');
    el.classList.add('iiz__zoom-portal');
    return el;
  }),
      portal = _useState[0];

  (0,react.useEffect)(function () {
    document.body.appendChild(portal);
    return function () {
      return document.body.removeChild(portal);
    };
  }, [portal]);
  return (0,react_dom.createPortal)(children, portal);
};

FullscreenPortal.propTypes = {
  children: (prop_types_default()).element
};
/* harmony default export */ var components_FullscreenPortal = (FullscreenPortal);
;// CONCATENATED MODULE: ./node_modules/react-inner-image-zoom/es/InnerImageZoom/InnerImageZoom.js
var _this = undefined;







var InnerImageZoom = function InnerImageZoom(_ref) {
  var _ref$moveType = _ref.moveType,
      moveType = _ref$moveType === void 0 ? 'pan' : _ref$moveType,
      _ref$zoomType = _ref.zoomType,
      zoomType = _ref$zoomType === void 0 ? 'click' : _ref$zoomType,
      src = _ref.src,
      sources = _ref.sources,
      width = _ref.width,
      height = _ref.height,
      hasSpacer = _ref.hasSpacer,
      _ref$imgAttributes = _ref.imgAttributes,
      imgAttributes = _ref$imgAttributes === void 0 ? {} : _ref$imgAttributes,
      zoomSrc = _ref.zoomSrc,
      _ref$zoomScale = _ref.zoomScale,
      zoomScale = _ref$zoomScale === void 0 ? 1 : _ref$zoomScale,
      zoomPreload = _ref.zoomPreload,
      _ref$fadeDuration = _ref.fadeDuration,
      fadeDuration = _ref$fadeDuration === void 0 ? 150 : _ref$fadeDuration,
      fullscreenOnMobile = _ref.fullscreenOnMobile,
      _ref$mobileBreakpoint = _ref.mobileBreakpoint,
      mobileBreakpoint = _ref$mobileBreakpoint === void 0 ? 640 : _ref$mobileBreakpoint,
      hideCloseButton = _ref.hideCloseButton,
      hideHint = _ref.hideHint,
      className = _ref.className,
      afterZoomIn = _ref.afterZoomIn,
      afterZoomOut = _ref.afterZoomOut;
  var img = (0,react.useRef)(null);
  var zoomImg = (0,react.useRef)(null);
  var imgProps = (0,react.useRef)({});

  var _useState = (0,react.useState)(zoomPreload),
      isActive = _useState[0],
      setIsActive = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isTouch = _useState2[0],
      setIsTouch = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isZoomed = _useState3[0],
      setIsZoomed = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      isFullscreen = _useState4[0],
      setIsFullscreen = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      isDragging = _useState5[0],
      setIsDragging = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      isValidDrag = _useState6[0],
      setIsValidDrag = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      isFading = _useState7[0],
      setIsFading = _useState7[1];

  var _useState8 = (0,react.useState)(moveType),
      currentMoveType = _useState8[0],
      setCurrentMoveType = _useState8[1];

  var _useState9 = (0,react.useState)(0),
      left = _useState9[0],
      setLeft = _useState9[1];

  var _useState10 = (0,react.useState)(0),
      top = _useState10[0],
      setTop = _useState10[1];

  var handleMouseEnter = function handleMouseEnter(e) {
    setIsActive(true);
    setIsFading(false);
    zoomType === 'hover' && !isZoomed && handleClick(e);
  };

  var handleTouchStart = function handleTouchStart() {
    setIsTouch(true);
    setIsFullscreen(getFullscreenStatus(fullscreenOnMobile, mobileBreakpoint));
    setCurrentMoveType('drag');
  };

  var handleClick = function handleClick(e) {
    if (isZoomed) {
      if (isTouch) {
        hideCloseButton && handleClose(e);
      } else {
        !isValidDrag && zoomOut();
      }

      return;
    }

    isTouch && setIsActive(true);

    if (zoomImg.current) {
      handleLoad({
        target: zoomImg.current
      });
      zoomIn(e.pageX, e.pageY);
    } else {
      imgProps.current.onLoadCallback = zoomIn.bind(_this, e.pageX, e.pageY);
    }
  };

  var handleLoad = function handleLoad(e) {
    var scaledDimensions = getScaledDimensions(e.target, zoomScale);
    zoomImg.current = e.target;
    zoomImg.current.setAttribute('width', scaledDimensions.width);
    zoomImg.current.setAttribute('height', scaledDimensions.height);
    imgProps.current.scaledDimensions = scaledDimensions;
    imgProps.current.bounds = getBounds(img.current, false);
    imgProps.current.ratios = getRatios(imgProps.current.bounds, scaledDimensions);

    if (imgProps.current.onLoadCallback) {
      imgProps.current.onLoadCallback();
      imgProps.current.onLoadCallback = null;
    }
  };

  var handleMouseMove = function handleMouseMove(e) {
    var left = e.pageX - imgProps.current.offsets.x;
    var top = e.pageY - imgProps.current.offsets.y;
    left = Math.max(Math.min(left, imgProps.current.bounds.width), 0);
    top = Math.max(Math.min(top, imgProps.current.bounds.height), 0);
    setLeft(left * -imgProps.current.ratios.x);
    setTop(top * -imgProps.current.ratios.y);
  };

  var handleDragStart = function handleDragStart(e) {
    var pageX = typeof e.pageX === 'number' ? e.pageX : e.changedTouches[0].pageX;
    var pageY = typeof e.pageY === 'number' ? e.pageY : e.changedTouches[0].pageY;
    imgProps.current.offsets = getOffsets(pageX, pageY, zoomImg.current.offsetLeft, zoomImg.current.offsetTop);
    setIsDragging(true);

    if (!isTouch) {
      imgProps.current.eventPosition = {
        x: e.pageX,
        y: e.pageY
      };
    }
  };

  var handleDragMove = (0,react.useCallback)(function (e) {
    e.stopPropagation();
    var pageX = typeof e.pageX === 'number' ? e.pageX : e.changedTouches[0].pageX;
    var pageY = typeof e.pageY === 'number' ? e.pageY : e.changedTouches[0].pageY;
    var left = pageX - imgProps.current.offsets.x;
    var top = pageY - imgProps.current.offsets.y;
    left = Math.max(Math.min(left, 0), (imgProps.current.scaledDimensions.width - imgProps.current.bounds.width) * -1);
    top = Math.max(Math.min(top, 0), (imgProps.current.scaledDimensions.height - imgProps.current.bounds.height) * -1);
    setLeft(left);
    setTop(top);
  }, []);

  var handleDragEnd = function handleDragEnd(e) {
    setIsDragging(false);

    if (!isTouch) {
      var moveX = Math.abs(e.pageX - imgProps.current.eventPosition.x);
      var moveY = Math.abs(e.pageY - imgProps.current.eventPosition.y);
      setIsValidDrag(moveX > 5 || moveY > 5);
    }
  };

  var handleMouseLeave = function handleMouseLeave(e) {
    currentMoveType === 'drag' && isZoomed ? handleDragEnd(e) : handleClose(e);
  };

  var handleClose = function handleClose(e) {
    if (!(!isTouch && e.target.classList.contains('iiz__close'))) {
      if (!isZoomed || isFullscreen || !fadeDuration) {
        handleFadeOut({}, true);
      } else {
        setIsFading(true);
      }
    }

    zoomOut();
  };

  var handleFadeOut = function handleFadeOut(e, noTransition) {
    if (noTransition || e.propertyName === 'opacity' && img.current.contains(e.target)) {
      if (zoomPreload && isTouch || !zoomPreload) {
        zoomImg.current = null;
        imgProps.current = getDefaults();
        setIsActive(false);
      }

      setIsTouch(false);
      setIsFullscreen(false);
      setCurrentMoveType(moveType);
      setIsFading(false);
    }
  };

  var initialMove = function initialMove(pageX, pageY) {
    imgProps.current.offsets = getOffsets(window.pageXOffset, window.pageYOffset, -imgProps.current.bounds.left, -imgProps.current.bounds.top);
    handleMouseMove({
      pageX: pageX,
      pageY: pageY
    });
  };

  var initialDrag = function initialDrag(pageX, pageY) {
    var initialPageX = (pageX - (window.pageXOffset + imgProps.current.bounds.left)) * -imgProps.current.ratios.x;
    var initialPageY = (pageY - (window.pageYOffset + imgProps.current.bounds.top)) * -imgProps.current.ratios.y;
    initialPageX = initialPageX + (isFullscreen ? (window.innerWidth - imgProps.current.bounds.width) / 2 : 0);
    initialPageY = initialPageY + (isFullscreen ? (window.innerHeight - imgProps.current.bounds.height) / 2 : 0);
    imgProps.current.bounds = getBounds(img.current, isFullscreen);
    imgProps.current.offsets = getOffsets(0, 0, 0, 0);
    handleDragMove({
      changedTouches: [{
        pageX: initialPageX,
        pageY: initialPageY
      }],
      preventDefault: function preventDefault() {},
      stopPropagation: function stopPropagation() {}
    });
  };

  var zoomIn = function zoomIn(pageX, pageY) {
    setIsZoomed(true);
    currentMoveType === 'drag' ? initialDrag(pageX, pageY) : initialMove(pageX, pageY);
    afterZoomIn && afterZoomIn();
  };

  var zoomOut = function zoomOut() {
    setIsZoomed(false);
    afterZoomOut && afterZoomOut();
  };

  var getDefaults = function getDefaults() {
    return {
      onLoadCallback: null,
      bounds: {},
      offsets: {},
      ratios: {},
      eventPosition: {},
      scaledDimensions: {}
    };
  };

  var getBounds = function getBounds(img, isFullscreen) {
    if (isFullscreen) {
      return {
        width: window.innerWidth,
        height: window.innerHeight,
        left: 0,
        top: 0
      };
    }

    return img.getBoundingClientRect();
  };

  var getOffsets = function getOffsets(pageX, pageY, left, top) {
    return {
      x: pageX - left,
      y: pageY - top
    };
  };

  var getRatios = function getRatios(bounds, dimensions) {
    return {
      x: (dimensions.width - bounds.width) / bounds.width,
      y: (dimensions.height - bounds.height) / bounds.height
    };
  };

  var getFullscreenStatus = function getFullscreenStatus(fullscreenOnMobile, mobileBreakpoint) {
    return fullscreenOnMobile && window.matchMedia && window.matchMedia("(max-width: " + mobileBreakpoint + "px)").matches;
  };

  var getScaledDimensions = function getScaledDimensions(zoomImg, zoomScale) {
    return {
      width: zoomImg.naturalWidth * zoomScale,
      height: zoomImg.naturalHeight * zoomScale
    };
  };

  var zoomImageProps = {
    src: zoomSrc || src,
    fadeDuration: isFullscreen ? 0 : fadeDuration,
    top: top,
    left: left,
    isZoomed: isZoomed,
    onLoad: handleLoad,
    onDragStart: currentMoveType === 'drag' ? handleDragStart : null,
    onDragEnd: currentMoveType === 'drag' ? handleDragEnd : null,
    onClose: !hideCloseButton && currentMoveType === 'drag' ? handleClose : null,
    onFadeOut: isFading ? handleFadeOut : null
  };
  (0,react.useEffect)(function () {
    imgProps.current = getDefaults();
  }, []);
  (0,react.useEffect)(function () {
    getFullscreenStatus(fullscreenOnMobile, mobileBreakpoint) && setIsActive(false);
  }, [fullscreenOnMobile, mobileBreakpoint]);
  (0,react.useEffect)(function () {
    if (!zoomImg.current) {
      return;
    }

    var eventType = isTouch ? 'touchmove' : 'mousemove';

    if (isDragging) {
      zoomImg.current.addEventListener(eventType, handleDragMove, {
        passive: true
      });
    } else {
      zoomImg.current.removeEventListener(eventType, handleDragMove);
    }
  }, [isDragging, isTouch, handleDragMove]);
  return /*#__PURE__*/react.createElement("figure", {
    className: "iiz " + (currentMoveType === 'drag' ? 'iiz--drag' : '') + " " + (className ? className : ''),
    style: {
      width: width
    },
    ref: img,
    onTouchStart: isZoomed ? null : handleTouchStart,
    onClick: handleClick,
    onMouseEnter: isTouch ? null : handleMouseEnter,
    onMouseMove: currentMoveType === 'drag' || !isZoomed ? null : handleMouseMove,
    onMouseLeave: isTouch ? null : handleMouseLeave
  }, /*#__PURE__*/react.createElement(components_Image, {
    src: src,
    sources: sources,
    width: width,
    height: height,
    hasSpacer: hasSpacer,
    imgAttributes: imgAttributes,
    fadeDuration: fadeDuration,
    isZoomed: isZoomed
  }), isActive && /*#__PURE__*/react.createElement(react.Fragment, null, isFullscreen ? /*#__PURE__*/react.createElement(components_FullscreenPortal, null, /*#__PURE__*/react.createElement(components_ZoomImage, zoomImageProps)) : /*#__PURE__*/react.createElement(components_ZoomImage, zoomImageProps)), !hideHint && !isZoomed && /*#__PURE__*/react.createElement("span", {
    className: "iiz__btn iiz__hint"
  }));
};

InnerImageZoom.propTypes =  false ? 0 : {};
/* harmony default export */ var InnerImageZoom_InnerImageZoom = (InnerImageZoom);
;// CONCATENATED MODULE: ./node_modules/react-inner-image-zoom/es/InnerImageZoom/index.js

/* harmony default export */ var es_InnerImageZoom = (InnerImageZoom_InnerImageZoom);
;// CONCATENATED MODULE: ./node_modules/react-inner-image-zoom/es/index.js

/* harmony default export */ var es = (es_InnerImageZoom);

;// CONCATENATED MODULE: ./src/screens/product/gallery/elements.ts

function gallery_elements_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n\n  > :first-child {\n    margin-right: ",
        "px;\n  }\n"
    ]);
    gallery_elements_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function gallery_elements_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin-top: ",
        "px;\n\n  > :not(:last-child) {\n    margin-bottom: ",
        "px;\n  }\n"
    ]);
    gallery_elements_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function gallery_elements_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border: 1px solid transparent;\n  border-color: ",
        ";\n  cursor: pointer;\n  height: ",
        "px;\n  object-fit: contain;\n  transition: border-color 0.2s ease-in;\n  width: ",
        "px;\n\n  :hover {\n    border-color: ",
        ";\n  }\n"
    ]);
    gallery_elements_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var gallery_elements_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ae48137d-0"
})(gallery_elements_templateObject(), theme/* default.spacing.cozy */.Z.spacing.cozy * 8);
var ThumbnailsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ae48137d-1"
})(gallery_elements_templateObject1(), theme/* default.spacing.comfortable */.Z.spacing.comfortable, theme/* default.spacing.comfortable */.Z.spacing.comfortable);
var getSelectedColor = function(props) {
    return props.theme.colors.primary;
};
var getThumbnailBorderColor = function(props) {
    var selected = props.selected;
    if (selected) {
        return getSelectedColor(props);
    }
    return "transparent";
};
var Thumbnail = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-ae48137d-2"
})(gallery_elements_templateObject2(), theme/* default.colors.white */.Z.colors.white, getThumbnailBorderColor, theme/* default.spacing.cozy */.Z.spacing.cozy * 8, theme/* default.spacing.cozy */.Z.spacing.cozy * 8, getSelectedColor);

// EXTERNAL MODULE: ./node_modules/react-inner-image-zoom/lib/InnerImageZoom/styles.css
var styles = __webpack_require__(51145);
;// CONCATENATED MODULE: ./src/screens/product/gallery/index.tsx









function Gallery(props) {
    var alt = props.alt, photos = props.photos, style = props.style, className = props.className, selectedPhotoIndex = props.selectedPhotoIndex, setSelectedPhotoIndex = props.setSelectedPhotoIndex;
    var currentPhoto = photos[selectedPhotoIndex];
    var onThumbnailClick = function(index) {
        setSelectedPhotoIndex(index);
    };
    var renderThumbnail = function(photo, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Thumbnail, {
            src: utils/* cloudinary.applyTransformations */.nl.applyTransformations(photo, constants/* transformations.GALLERY_THUMBNAIL */.S7.GALLERY_THUMBNAIL),
            selected: index === selectedPhotoIndex,
            onClick: function() {
                return onThumbnailClick(index);
            }
        }, "product-image-".concat(index));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(gallery_elements_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbnailsContainer, {
                style: style,
                className: className,
                children: (0,lodash.map)(photos, renderThumbnail)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es, {
                src: utils/* cloudinary.applyTransformations */.nl.applyTransformations(currentPhoto, constants/* transformations.GALLERY_FULL_IMAGE */.S7.GALLERY_FULL_IMAGE),
                hideHint: true,
                hideCloseButton: true,
                width: theme/* default.spacing.cozy */.Z.spacing.cozy * 51,
                imgAttributes: {
                    alt: alt
                },
                className: "inner-image-zoom-desktop"
            })
        ]
    });
}
/* harmony default export */ var gallery = (Gallery);

;// CONCATENATED MODULE: ./src/screens/product/not-available/index.tsx

function not_available_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-top: ",
        "px;\n\n  > strong {\n    margin-left: ",
        "px;\n    margin-right: ",
        "px;\n  }\n"
    ]);
    not_available_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function not_available_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        "px;\n"
    ]);
    not_available_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var LinkContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-994eae0f-0"
})(not_available_templateObject(), function(props) {
    return props.theme.spacing.comfortable;
}, function(props) {
    return props.theme.spacing.cozy;
}, function(props) {
    return props.theme.spacing.cozy;
});
var StyledText = (0,styled_components_browser_esm/* default */.ZP)(truck_label/* default */.Z).withConfig({
    componentId: "sc-994eae0f-1"
})(not_available_templateObject1(), function(props) {
    return props.theme.spacing.relaxed;
});
function NotAvailable(props) {
    var activeVariant = props.activeVariant;
    var modalManager = (0,use_modal_manager/* default */.Z)();
    var multiDistributorSession = (0,hooks/* useMultiDistributorSession */.kS)().multiDistributorSession;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CTABasicContent, {
        name: activeVariant.name,
        presentation: activeVariant.presentation,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledText, {
                as: "p",
                $textStyle: "h3Semibold",
                children: multiDistributorSession ? "No disponible en la direcci\xf3n seleccionada" : "Selecciona una direcci\xf3n para ver disponibilidad"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(truck_anchor/* default */.Z, {
                        as: "span",
                        style: {
                            cursor: "pointer"
                        },
                        $textStyle: "h5Semibold",
                        onClick: function() {
                            modalManager.openModal(shipping_modal/* default */.Z);
                        },
                        children: multiDistributorSession ? "Cambiar direcci\xf3n" : "Seleccionar direcci\xf3n"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "\xb7"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(truck_anchor/* default */.Z, {
                        href: "/",
                        $textStyle: "h5Semibold",
                        children: "Volver al cat\xe1logo"
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/react-media/esm/react-media.js + 4 modules
var react_media = __webpack_require__(8376);
// EXTERNAL MODULE: ./src/components/catalog/index.js + 1 modules
var catalog = __webpack_require__(9333);
// EXTERNAL MODULE: ./src/screens/home/section/index.tsx
var section = __webpack_require__(27026);
;// CONCATENATED MODULE: ./src/screens/product/related-products/index.tsx

function related_products_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        "px;\n  width: 100%;\n"
    ]);
    related_products_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function related_products_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    related_products_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function related_products_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  width: 100%;\n\n  &.is-draggable {\n    cursor: move;\n    cursor: grab;\n  }\n\n  &.is-dragging {\n    cursor: grabbing;\n  }\n"
    ]);
    related_products_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function related_products_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  -khtml-user-select: none;\n  -webkit-tap-highlight-color: transparent;\n  -webkit-touch-callout: none;\n  display: flex;\n  flex-wrap: nowrap;\n  user-select: none;\n"
    ]);
    related_products_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function related_products_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  filter: drop-shadow(0px 0px 0px rgba(63, 63, 68, 0.05)) drop-shadow(0px 1px 3px rgba(63, 63, 68, 0.15));\n  margin: 0 ",
        "px;\n  position: absolute;\n  top: 48%;\n  transform: translateY(-58%);\n  z-index: 10;\n\n  &:hover {\n    background: ",
        ";\n    filter: drop-shadow(0px 2px 2px rgba(63, 63, 68, 0.2)) drop-shadow(0px 1px 3px rgba(63, 63, 68, 0.15));\n\n    > svg {\n      fill: ",
        ";\n    }\n  }\n"
    ]);
    related_products_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
















var StyledSection = (0,styled_components_browser_esm/* default */.ZP)(section/* default */.Z).withConfig({
    componentId: "sc-3814039a-0"
})(related_products_templateObject(), function(props) {
    return props.theme.spacing.comfortable;
});
var StyledSliderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3814039a-1"
})(related_products_templateObject1());
var StyledSliderViewport = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3814039a-2"
})(related_products_templateObject2());
var StyledCatalog = (0,styled_components_browser_esm/* default */.ZP)(catalog/* default */.Z).withConfig({
    componentId: "sc-3814039a-3"
})(related_products_templateObject3());
// TODO: move shadows to `elevation` when the elevations are defined by design team
var SliderArrow = (0,styled_components_browser_esm/* default */.ZP)(truck_button/* default.Circular */.Z.Circular).withConfig({
    componentId: "sc-3814039a-4"
})(related_products_templateObject4(), function(props) {
    return props.theme.spacing.cozy;
}, function(props) {
    return props.theme.colors.white;
}, function(props) {
    return props.theme.colors.secondary;
});
function Slider(props) {
    var products = props.products, slidesToScroll = props.slidesToScroll;
    var isDraggingRef = react.useRef(false);
    var carousel = (0,hooks/* useCarousel */.vr)({
        slidesToScroll: slidesToScroll
    });
    var router = (0,next_router.useRouter)();
    react.useEffect(function() {
        var handleScroll = function() {
            isDraggingRef.current = true;
        };
        var handlePointerDown = function() {
            isDraggingRef.current = false;
        };
        if (carousel.emblaApi) {
            carousel.emblaApi.reInit({
                slidesToScroll: slidesToScroll
            });
            carousel.emblaApi.on("scroll", handleScroll);
            carousel.emblaApi.on("pointerDown", handlePointerDown);
        }
        return function() {
            var ref, ref1;
            (ref = carousel.emblaApi) === null || ref === void 0 ? void 0 : ref.off("scroll", handleScroll);
            (ref1 = carousel.emblaApi) === null || ref1 === void 0 ? void 0 : ref1.off("pointerDown", handlePointerDown);
        };
    }, [
        carousel.emblaApi,
        slidesToScroll
    ]);
    if ((0,lodash.size)(products) <= slidesToScroll) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCatalog, {
            products: products
        });
    }
    var handleProductOnClick = function(e, productUrl) {
        e.preventDefault();
        if (!isDraggingRef.current) {
            router.push(productUrl).then(function() {
                return window.scrollTo(0, 0);
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSliderContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSliderViewport, {
                ref: carousel.ui.viewportRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCatalog, {
                    productOnClick: handleProductOnClick,
                    products: products
                })
            }),
            carousel.ui.isPrevBtnEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderArrow, {
                color: "white",
                style: {
                    left: 0
                },
                onClick: carousel.ui.scrollToPrev,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                    type: "caret-left",
                    color: "secondary"
                })
            }),
            carousel.ui.isNextBtnEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderArrow, {
                color: "white",
                style: {
                    right: 0
                },
                onClick: carousel.ui.scrollToNext,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                    type: "caret-right",
                    color: "secondary"
                })
            })
        ]
    });
}
var slidesToScrollWithFF = {
    lg: 3,
    xl: 4
};
var slidesToScrollWithoutFF = {
    lg: 4,
    xl: 5
};
function RelatedProducts(props) {
    var ref;
    var productId = props.productId;
    var ref1 = (0,react_hooks_esm/* useQuery */.aM)(queries/* relatedProductsQuery */.c$, {
        variables: {
            productId: productId
        }
    }), data = ref1.data, loading = ref1.loading;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var products = data === null || data === void 0 ? void 0 : (ref = data.product) === null || ref === void 0 ? void 0 : ref.relatedProducts;
    var flagQueryFn = (0,toggled_esm/* useFlagQueryFn */.rt)();
    var isFullWidth = flagQueryFn(constants/* flagQueries.HAS_FULL_WIDTH */.mE.HAS_FULL_WIDTH);
    var slidesToScroll = isFullWidth ? slidesToScrollWithoutFF : slidesToScrollWithFF;
    if (loading || (0,lodash.isEmpty)(products)) {
        return null;
    }
    // FIXME: use Slider component
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSection, {
        title: "Productos relacionados",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(media/* default */.Z, {
            mobile: /*#__PURE__*/ (0,jsx_runtime.jsx)(catalog/* default */.Z, {
                products: products,
                collapsed: true
            }),
            desktop: function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_media/* default */.Z, {
                    query: {
                        minWidth: theme.breakpoints.xl
                    },
                    children: function(isBigScreen) {
                        return(// prettier-ignore
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider, {
                            products: products,
                            slidesToScroll: isBigScreen ? slidesToScroll.xl : slidesToScroll.lg
                        }));
                    }
                });
            }
        })
    });
}

;// CONCATENATED MODULE: ./src/screens/product/set-variants-attributes.js



var pushOrCreateKey = function(obj, value, name) {
    var found = obj[name];
    if (found) {
        return found.push(value);
    }
    return (0,lodash.assign)(obj, (0,_define_property/* default */.Z)({}, name, [
        value
    ]));
};
var uniqSortedValues = function(values) {
    return (0,lodash.sortBy)((0,lodash.uniq)(values));
};
var toObject = function(attributes, attribute) {
    var name = attribute.name, value = attribute.value;
    return (0,lodash.assign)(attributes, (0,_define_property/* default */.Z)({}, name, value));
};
var refineAttributes = function(variant) {
    var attributes = variant.attributes;
    var refinedAttributes = (0,lodash.reduce)(attributes, toObject, {});
    (0,lodash.assign)(variant, {
        refinedAttributes: refinedAttributes
    });
};
var reduceAttributes = function(result, attribute) {
    (0,lodash.each)(attribute, pushOrCreateKey.bind(null, result));
    return result;
};
var groupVariantsAttributes = function(variants) {
    var attributes = (0,lodash.flatMap)(variants, "refinedAttributes");
    var reduced = (0,lodash.reduce)(attributes, reduceAttributes, {});
    return (0,lodash.mapValues)(reduced, uniqSortedValues);
};
var setVariantsAttributes = function(product) {
    var variants = product.variants;
    var related = [
        product
    ].concat((0,_to_consumable_array/* default */.Z)(variants));
    (0,lodash.each)(related, refineAttributes);
    (0,lodash.assign)(product, {
        variantsAttributes: groupVariantsAttributes(related)
    });
};
/* harmony default export */ var set_variants_attributes = (setVariantsAttributes);

;// CONCATENATED MODULE: ./src/screens/product/slider/index.tsx







var slider_Slider = function(props) {
    var alt = props.alt, photos = props.photos;
    var renderImage = function(photo, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(es, {
            src: utils/* cloudinary.applyTransformations */.nl.applyTransformations(photo, constants/* transformations.PRODUCT_SLIDER */.S7.PRODUCT_SLIDER),
            hideHint: true,
            hideCloseButton: true,
            imgAttributes: {
                alt: alt
            },
            className: "inner-image-zoom-mobile"
        }, "product-image-".concat(index));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Carousel */.lr, {
        dataSource: photos,
        renderer: renderImage
    });
};
/* harmony default export */ var slider = (slider_Slider);

;// CONCATENATED MODULE: ./src/screens/product/index.tsx





function product_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  bottom: ",
        "px;\n  height: ",
        "px;\n  left: 0;\n  position: absolute;\n"
    ]);
    product_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function product_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        void 0,
        void 0
    ]);
    product_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
































function product_Content(props) {
    var ref;
    var fallbackProduct = props.fallbackProduct, activeVariant = props.activeVariant, isAvailable = props.isAvailable, selectedPhotoIndex = props.selectedPhotoIndex, setSelectedPhotoIndex = props.setSelectedPhotoIndex;
    var category = (ref = fallbackProduct.mainVariant.category) === null || ref === void 0 ? void 0 : ref.parent;
    var subcategory = fallbackProduct.mainVariant.category;
    var route = "/c/".concat(category === null || category === void 0 ? void 0 : category.slug, "-").concat(category === null || category === void 0 ? void 0 : category.encodedId, "/").concat(subcategory === null || subcategory === void 0 ? void 0 : subcategory.slug, "-").concat(subcategory === null || subcategory === void 0 ? void 0 : subcategory.encodedId, "/");
    var ref1;
    var name = (ref1 = activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.name) !== null && ref1 !== void 0 ? ref1 : fallbackProduct.name;
    var ref2;
    var photos = (ref2 = activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.photos) !== null && ref2 !== void 0 ? ref2 : fallbackProduct.photos;
    var sliderPhotos = !(0,lodash.isEmpty)(photos) ? (0,lodash.map)(photos, "url") : [
        constants/* images.PRODUCT_PLACEHOLDER */.Wc.PRODUCT_PLACEHOLDER
    ];
    var sliderProps = {
        alt: name,
        photos: sliderPhotos
    };
    var items = [
        {
            label: "Inicio",
            route: "/"
        },
        {
            label: subcategory === null || subcategory === void 0 ? void 0 : subcategory.name,
            route: route
        },
        {
            label: name
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(elements_ContentContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Media */.pU, {
                desktop: /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb, {
                    items: items,
                    productIsAvailable: isAvailable
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InnerContentContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Media */.pU, {
                        mobile: /*#__PURE__*/ (0,jsx_runtime.jsx)(slider, (0,_object_spread/* default */.Z)({}, sliderProps)),
                        desktop: /*#__PURE__*/ (0,jsx_runtime.jsx)(gallery, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sliderProps), {
                            selectedPhotoIndex: selectedPhotoIndex,
                            setSelectedPhotoIndex: setSelectedPhotoIndex
                        }))
                    }),
                    isAvailable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CTA, (0,_object_spread/* default */.Z)({}, props)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NotAvailable, (0,_object_spread/* default */.Z)({}, props))
                ]
            })
        ]
    });
}
var buttonStyles = (0,styled_components_browser_esm/* css */.iv)(product_templateObject(), theme/* default.colors.white */.Z.colors.white, theme/* default.spacing.compact */.Z.spacing.compact * 3, theme/* default.spacing.comfortable */.Z.spacing.comfortable * 2);
function VariantManager(props) {
    var product = props.product, cart = props.cart, variants = props.variants, isAvailable = props.isAvailable;
    var initialValue = {
        fallbackProduct: product,
        activeVariant: product
    };
    var variantManager = (0,use_variant_manager/* default */.Z)(initialValue, variants);
    var vendor = (0,use_vendor/* default */.Z)();
    var isMobile = (0,hooks/* useIsMobile */.dD)();
    var hasReviewFF = (0,toggled_esm/* useFlag */.P5)(constants/* flags.HAS_REVIEW */.id.HAS_REVIEW);
    var hasRelatedProducts = (0,toggled_esm/* useFlag */.P5)(constants/* flags.RELATED_PRODUCTS */.id.RELATED_PRODUCTS);
    var fallbackProduct = variantManager.fallbackProduct, activeVariant = variantManager.activeVariant, onVariantChange = variantManager.onVariantChange, selectedPhotoIndex = variantManager.selectedPhotoIndex, setSelectedPhotoIndex = variantManager.setSelectedPhotoIndex;
    react.useEffect(function() {
        if (!activeVariant) {
            return;
        }
        analytics/* analytics.viewItem */.co.viewItem(activeVariant, {
            vendor: vendor
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.sku
    ]);
    react.useEffect(function() {
        (0,utils/* updateQuantitiesInProducts */.KI)(variants, cart);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fallbackProduct,
        cart
    ]);
    var description = fallbackProduct.mainVariant.description;
    var metaData = (0,lodash.pick)(activeVariant || fallbackProduct, [
        "name",
        "description",
        "seoTitle",
        "seoDescription",
        "photos",
        "sku",
        "slug",
        "stock",
        "pricing",
        "reviewStats", 
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(true), 2), clamped = ref[0], setClamped = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(true), 2), showReadMore = ref1[0], setShowReadMore = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isEvaluated = ref2[0], setIsEvaluated = ref2[1];
    var IMG_REGEX = /<img[^>]*src=('|")([^'"]+)('|")[^>]*>/;
    var hasImage = IMG_REGEX.test(description);
    var handleClick = function() {
        return setClamped(!clamped);
    };
    var onLoad = function() {
        return setIsEvaluated(true);
    };
    var aboutContainerRef = react.useCallback(function(node) {
        if (node && isEvaluated && clamped) {
            setShowReadMore(node.clientHeight < node.scrollHeight);
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isEvaluated
    ]);
    react.useEffect(function() {
        if (!hasImage) {
            setIsEvaluated(true);
        }
    }, [
        hasImage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Meta.Product */.h_.Product, (0,_object_spread/* default */.Z)({}, metaData)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(product_Content, {
                product: product,
                fallbackProduct: fallbackProduct,
                activeVariant: activeVariant,
                onVariantChange: onVariantChange,
                variants: variants,
                isAvailable: isAvailable,
                selectedPhotoIndex: selectedPhotoIndex,
                setSelectedPhotoIndex: setSelectedPhotoIndex
            }),
            description && /*#__PURE__*/ (0,jsx_runtime.jsxs)(AboutContainer, {
                ref: aboutContainerRef,
                clamped: clamped,
                showReadMore: showReadMore,
                style: {
                    maxHeight: clamped && isMobile ? "".concat(theme/* default.spacing.relaxed */.Z.spacing.relaxed * 13, "px") : null
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(truck_label/* default */.Z, {
                        as: "h4",
                        $textStyle: "h4Semibold",
                        children: "Acerca del producto"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(wysiwyg/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(truck_label/* default */.Z, {
                        as: "span",
                        className: "wysiwyg",
                        children: (0,html_react_parser/* default */.ZP)(description, {
                            replace: function(domNode) {
                                var typedDomNode = domNode;
                                if (typedDomNode.attribs && typedDomNode.name === "img") {
                                    var _$props = (0,html_react_parser/* attributesToProps */.e_)(typedDomNode.attribs);
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _$props), {
                                        onLoad: onLoad
                                    }));
                                }
                            }
                        })
                    }),
                    showReadMore && /*#__PURE__*/ (0,jsx_runtime.jsxs)(_StyledButtonPlain, {
                        onClick: handleClick,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(truck_label/* default */.Z, {
                                $textStyle: "h5Semibold",
                                $color: "info",
                                children: [
                                    "Ver ",
                                    clamped ? "m\xe1s" : "menos"
                                ]
                            }),
                            "\xa0",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                type: clamped ? "caret-down" : "caret-up",
                                size: "sm",
                                interactive: false,
                                color: "info"
                            })
                        ]
                    })
                ]
            }),
            isAvailable && hasRelatedProducts && /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedProducts, {
                productId: product.id
            }),
            isAvailable && hasReviewFF && /*#__PURE__*/ (0,jsx_runtime.jsx)(containers_product_review, {
                productSlug: product.slug
            })
        ]
    });
}
function ProductScreen(props) {
    var productSlug = props.productSlug, ssrProduct = props.ssrProduct;
    var vendor = (0,use_vendor/* default */.Z)();
    var isAvailable = !(0,lodash.isNil)(ssrProduct) ? ssrProduct.vendor.id === vendor.id : true;
    var productResponse = (0,react_hooks_esm/* useQuery */.aM)(queries/* vendorProductQuery */.C6, {
        skip: !!ssrProduct && !is_browser/* default */.Z || !isAvailable,
        variables: {
            slug: productSlug
        }
    });
    var userCartResponse = (0,react_hooks_esm/* useQuery */.aM)(queries/* userCartQuery */.EA, {
        skip: !isAvailable
    });
    var loading = (0,lodash.some)([
        userCartResponse,
        productResponse
    ], "loading");
    var renderContent = function() {
        var ref, ref1, ref2, ref3;
        if (loading) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Loader */.nt, {});
        }
        var ref4;
        var product = (ref4 = (ref = productResponse.data) === null || ref === void 0 ? void 0 : (ref1 = ref.vendor) === null || ref1 === void 0 ? void 0 : ref1.product) !== null && ref4 !== void 0 ? ref4 : ssrProduct;
        if (!product) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledErrorComponent, {
                statusCode: constants/* httpStatusCodes.NOT_FOUND */.y3.NOT_FOUND
            });
        }
        var cart = (ref2 = userCartResponse.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.user) === null || ref3 === void 0 ? void 0 : ref3.cart;
        var allVariants = [
            product
        ].concat((0,_to_consumable_array/* default */.Z)(product.variants));
        var setGetters = function(item) {
            if (item === product) {
                return;
            }
            (0,lodash.assign)(item, {
                get variantsAttributes () {
                    return product.variantsAttributes;
                },
                get mainVariant () {
                    return product.mainVariant;
                }
            });
        };
        if (isAvailable) {
            (0,utils/* updateQuantitiesInProducts */.KI)(allVariants, cart);
            set_variants_attributes(product);
            (0,lodash.each)(allVariants, setGetters);
        }
        return(/**
       * We need to re-mount when the product was changed and
       * re-initialize the state of the VariantManager
       * component.
       * @url https://github.com/facebook/react/issues/14830#issuecomment-535546574
       */ /*#__PURE__*/ (0,jsx_runtime.jsx)(VariantManager, {
            product: product,
            cart: cart,
            variants: allVariants,
            isAvailable: isAvailable
        }, "product-screen-variant-manager-".concat(product.id)));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts/* MainLayout */.Zn, {
        children: renderContent()
    });
}
/* harmony default export */ var product = (ProductScreen);
var _StyledButtonPlain = (0,styled_components_browser_esm/* default */.ZP)(truck_button/* default.Plain */.Z.Plain).withConfig({
    componentId: "sc-76910c94-0"
})(product_templateObject1(), buttonStyles);

// EXTERNAL MODULE: ./pages/_error.tsx + 1 modules
var _error = __webpack_require__(60530);
;// CONCATENATED MODULE: ./pages/product.tsx










function ProductPage(props) {
    var productSlug = props.productSlug, ssrProduct = props.ssrProduct;
    if (!productSlug) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(_error["default"], {
            statusCode: constants/* httpStatusCodes.NOT_FOUND */.y3.NOT_FOUND
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Meta */.h_, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(product, {
                productSlug: productSlug,
                ssrProduct: ssrProduct
            })
        ]
    });
}
ProductPage.getInitialProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(pageContext) {
        var query, vendor, hasFlag, apolloClient, productSlug, isMultiDistributorD2C, ssrProduct, ssrProduct1, error;
        function getVendorProduct() {
            return _getVendorProduct.apply(this, arguments);
        }
        function _getVendorProduct() {
            _getVendorProduct = (0,_async_to_generator/* default */.Z)(function() {
                var response;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                apolloClient.query({
                                    query: queries/* vendorProductQuery */.C6,
                                    variables: {
                                        slug: productSlug
                                    }
                                })
                            ];
                        case 1:
                            response = _state.sent();
                            return [
                                2,
                                response.data.vendor.product
                            ];
                    }
                });
            });
            return _getVendorProduct.apply(this, arguments);
        }
        function getManufacturerProduct() {
            return _getManufacturerProduct.apply(this, arguments);
        }
        function _getManufacturerProduct() {
            _getManufacturerProduct = (0,_async_to_generator/* default */.Z)(function() {
                var response;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                apolloClient.query({
                                    query: queries/* manufacturerProductQuery */.lZ,
                                    variables: {
                                        slug: productSlug
                                    }
                                })
                            ];
                        case 1:
                            response = _state.sent();
                            return [
                                2,
                                response.data.manufacturer.product
                            ];
                    }
                });
            });
            return _getManufacturerProduct.apply(this, arguments);
        }
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    query = pageContext.query, vendor = pageContext.vendor, hasFlag = pageContext.hasFlag, apolloClient = pageContext.apolloClient;
                    productSlug = query.productSlug;
                    isMultiDistributorD2C = hasFlag(constants/* flags.MULTI_DISTRIBUTOR_D2C */.id.MULTI_DISTRIBUTOR_D2C);
                    if (is_browser/* default */.Z && !isMultiDistributorD2C) {
                        return [
                            2,
                            {
                                productSlug: productSlug
                            }
                        ];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        7,
                        ,
                        8
                    ]);
                    if (!!isMultiDistributorD2C) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        getVendorProduct()
                    ];
                case 2:
                    ssrProduct = _state.sent();
                    return [
                        2,
                        {
                            productSlug: productSlug,
                            ssrProduct: ssrProduct
                        }
                    ];
                case 3:
                    return [
                        4,
                        getManufacturerProduct()
                    ];
                case 4:
                    ssrProduct1 = _state.sent();
                    if (!(ssrProduct1.vendor.id === vendor.id)) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        getVendorProduct()
                    ];
                case 5:
                    ssrProduct1 = _state.sent();
                    _state.label = 6;
                case 6:
                    return [
                        2,
                        {
                            productSlug: productSlug,
                            ssrProduct: ssrProduct1
                        }
                    ];
                case 7:
                    error = _state.sent();
                    console.error(error);
                    if (pageContext.res) {
                        // eslint-disable-next-line no-param-reassign
                        pageContext.res.statusCode = constants/* httpStatusCodes.NOT_FOUND */.y3.NOT_FOUND;
                    }
                    return [
                        3,
                        8
                    ];
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
    return function(pageContext) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 58731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19521);
/* harmony import */ var _truck_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63216);
/* harmony import */ var _truck_label__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67734);
/* harmony import */ var _truck_theme__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78904);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  border-radius: ",
        "px;\n  display: flex;\n  margin-left: ",
        "px;\n  min-width: ",
        "px;\n  padding: ",
        "px;\n\n  svg {\n    margin-right: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var getBackgroundColor = function(props) {
    return props.$withBackground ? _truck_theme__WEBPACK_IMPORTED_MODULE_5__/* ["default"].colors */ .Z.colors[props.$background] : "trasparent";
};
var Message = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2a19bf5e-0"
})(_templateObject(), getBackgroundColor, _truck_theme__WEBPACK_IMPORTED_MODULE_5__/* ["default"].dimensions.borderRadius */ .Z.dimensions.borderRadius, _truck_theme__WEBPACK_IMPORTED_MODULE_5__/* ["default"].spacing.cozy */ .Z.spacing.cozy, _truck_theme__WEBPACK_IMPORTED_MODULE_5__/* ["default"].spacing.cozy */ .Z.spacing.cozy * 17, _truck_theme__WEBPACK_IMPORTED_MODULE_5__/* ["default"].spacing.cozy */ .Z.spacing.cozy, _truck_theme__WEBPACK_IMPORTED_MODULE_5__/* ["default"].spacing.cozy */ .Z.spacing.cozy);
var RatingMessage = function(props) {
    var icon = props.icon, label = props.label, color = props.color, background = props.background, withBackground = props.withBackground, className = props.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Message, {
        className: className,
        $withBackground: withBackground,
        $background: background,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_truck_icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                type: icon,
                color: color
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_truck_label__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                $color: color,
                as: "p",
                $textStyle: "h5Semibold",
                children: label
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RatingMessage);


/***/ }),

/***/ 27026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90512);



function Section(param) {
    var title = param.title, subtitle = param.subtitle, children = param.children, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("flex flex-col", className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
                className: "mb-4 ml-4 lg:mb-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                        className: "text-xl font-semibold",
                        children: title
                    }),
                    subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: subtitle
                    })
                ]
            }),
            children
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Section);


/***/ }),

/***/ 51145:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5935,157,3409,9774,2888,179], function() { return __webpack_exec__(49484), __webpack_exec__(85353); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);